// eslint-disable-next-line import/no-anonymous-default-export
export default {
  about: 'Apie Axioma Factory',
  appName: 'Flexi',
  data: 'Duomenys',
  tasks: 'Užduotys',
  logout: 'Atsijungti',
  password: 'Slaptažodis',
  email: 'El. paštas',
  login: 'Prisijungti',
  submit: 'Pateikti',
  passwordReset: 'Slaptažodžio atstatymas',
  forgotPassword: 'Pamiršote slaptažodį?',

  'password.NotNew': 'Įvestas slaptažodis negali būti vienodas senam',
  'user.newPwd': 'Naujas slaptažodis',
  'user.newPwdConf': 'Pakartokite naują slaptažodį',
  tokenExpired: 'Slaptažodžio keitimo nuoroda nebegalioja, prašome pateikti keitimo užklausą dar kartą',
  pwdsDontMatch: 'Pateikti slaptažodžiai turi būti vienodi',
  pwdMustContainNumbers: 'Slaptažodyje turi būti bent vienas skaičius',
  pwdMustContainSymbols: 'Slaptažodyje turi būti bent vienas iš šių simbolių: !@#$%^&*()_+{}[]:;<>,.?~-',
  pwdMustContainCaps: 'Slaptažodyje turi būti bent viena didžioji raidė',
  pwdLengthNotCorrect: 'Slaptažodžio ilgis turi būti tarp 8 ir 24 simbolių',
  passwordChanged: 'Slaptažodis pakeistas, už 10 sek. būsite peradresuotas atgal į prisijungimo puslapį',
  loginError: 'Įvestas neteisingas el. pašto adresas arba slaptažodis',
  pleaseWait: 'Prašome palaukti...',
  loggedOut: 'Sėkmingai atsijungėte nuo sistemos!',
  monday: 'Pirmadienis',
  tuesday: 'Antradienis',
  wednesday: 'Trečiadienis',
  thursday: 'Ketvirtadienis',
  friday: 'Penktadienis',
  saturday: 'Šeštadienis',
  sunday: 'Sekmadienis',
  header: 'Užduotis',
  type: 'Tipas',
  typeActivity: 'Veikla',
  typeBoard: 'Personalas/Vadyba',
  typeDevelopment: 'Strateginis vystymas',
  task: 'Užduotis',
  plannedResult: 'Tikslas',
  achievedResult: 'Rezultatas',
  rating: 'Įvertinimas',
  ratingMet: 'Tenkinantis',
  ratingNotMet: 'Netenkinantis',
  ratingAverage: 'Vidutinis',
  save: 'Saugoti',
  datePicker: 'Pasirinkite datą...',
  cancel: 'Atšaukti',
  back: 'Grįžti',
  ok: 'Pasirinkti',
  date: 'Data',
  weekday0: 'Pirmadienis',
  weekday1: 'Antradienis',
  weekday2: 'Trečiadienis',
  weekday3: 'Ketvirtadienis',
  weekday4: 'Penktadienis',
  weekday5: 'Šeštadienis',
  weekday6: 'Sekmadienis',
  week: 'Savaitė',
  user: 'Naudotojas',
  operator: 'Operatorius',
  findDriver: 'Ieškoti vairuotojo...',
  noResults: 'Nerasta',
  comments: 'Komentarai',
  delete: 'Pašalinti',
  help: 'Pagalba',
  confirmTaskDelete: 'Ar tikrai norite pašalinti užduotį?',
  myTasks: 'Mano užduotys',
  sessionExpired: 'Pasibaigė sesijai skirtas laikas. Prisijunkite iš naujo.',
  attachFile: 'Prisegti failą',
  confirmCommentDelete: 'Ar tikrai norite pašalinti komentarą?',
  commentEmail: 'Siųstas komentaras el. laišku.',
  required: 'Laukas privalomas',
  'no.data.found': 'Pagal pasirinktus kriterijus duomenų nerasta.',
  'system.error.message':
    'Įvyko klaida. Ekrano vaizdą prašome siųsti ' +
    'el.paštu <a href="mailto:support@axs.eu">support@axs.eu<a>',
  'system.backend.error.message':
    'Įvyko duomenų klaida. Ekrano vaizdą prašome siųsti ' +
    'el.paštu <a href="mailto:support@axs.eu">support@axs.eu<a>',
  'network.error.message': 'Įvyko tinklo klaida. Pakartokite veiksmą iš naujo.',
  'db.duplicate.error': 'Įrašas dubliuojasi',
  'empty.message': ' ',
  'create.new': 'Sukurti naują',
  'comment.add': 'Komentuoti',
  'comment.show': 'Rodyti komentarus',
  'changeLog.title': 'Pakeitimų istorija',

  'two.factor.authentication': "Dviguba autentifikacija",
  'enter.verification.code': "Įrašykite verifikacijos kodą",
  'confirmation.code': "Verifikacijos kodas",
  'remember.this.device': "Prisiminti šį įrenginį 14 dienų",
  'sending': "Siunčiama",
  'resend': "Siųsti iš naujo",
  'verify': "Tvirtinti",
  'invalid.verification.code': "Neteisingas verifikacijos kodas",
  'verification.code.sent': "Verifikacijos kodas išsiųstas",
  'twoFA.Request.Failed:': "Nepavyko išsiųsti verifikacijos kodo",

  'selectField.no.options': 'Pasirinkimų nerasta',
  'event.title': 'Parametrai',
  'event.indicatorName.filter': 'Parametras',
  'event.indicatorCode.filter': 'Parametro kodas',
  'event.eventDateTime.date': 'Parodymų data',
  'event.eventDateTime.time': 'Parodymų laikas',
  'event.valueFilter.filter': 'Reikšmė',

  'units.title': 'Matavimo vienetai',
  'unit.title': 'Matavimo vienetas',
  'unit.create.tooltip': 'Kurti matavimo vienetą',
  'unit.updated': 'Matavimo vienetas atnaujintas',
  'unit.created': 'Matavimo vienetas sukurtas',
  'unit.removed': 'Matavimo vienetas pašalintas',
  'unit.remove.error':
    'Matavimo vieneto nebegalima pašalinti nes jis turi sąryšių',
  'unit.filter': 'Ieškoti matavimo vieneto...',
  'unit.modify.title': 'Matavimo vieneto redagavimas',
  'unit.create.title': 'Matavimo vieneto kūrimas',
  'unit.delete.confirm': 'Ar tikrai norite pašalinti matavimo vienetą',
  'unit.name': 'Pavadinimas',
  'unit.abbreviation': 'Sutrumpinimas',
  'unit.type': 'Tipas',
  'unit.type.STRING': 'Tekstas',
  'unit.type.BOOLEAN': 'Yra/Nėra',
  'unit.type.INTEGER': 'Sveikas skaičius',
  'unit.type.FLOAT': 'Nesveikas skaičius',
  'unit.type.DATE': 'Data',

  'objects.title': 'Objektai',
  'object.title': 'Objektas',
  'object.create.tooltip': 'Kurti objektą',
  'object.updated': 'Objektas atnaujintas',
  'object.created': 'Objektas sukurtas',
  'object.removed': 'Objektas pašalintas',
  'object.remove.error': 'Objekto nebegalima pašalinti nes jis turi sąryšių',
  'object.filter': 'Ieškoti objekto...',
  'object.modify.title': 'Objekto redagavimas',
  'object.create.title': 'Objekto kūrimas',
  'object.delete.confirm': 'Ar tikrai norite pašalinti objektą',
  'object.name': 'Pavadinimas',
  'object.code': 'Kodas',
  'object.abbreviation': 'Trumpinys',
  'object.description': 'Aprašymas',
  'object.search': 'Ieškoti objekto...',
  "object.report.companyName": "Įmonės pavadinimas",
  "object.report.address": "Adresas",
  "object.report.city": "Miestas",
  "object.report.website": "Interneto svetainė",
  "object.report.phone": "Telefonas",
  "object.report.email": "El. paštas",
  "object.report.companyCode": "Įmonės kodas",
  "object.report.vatCode": "PVM mokėtojo kodas",
  "object.report.bankDetails": "Banko duomenys",
  "object.report.workAcceptedBy": "Darbus priėmė",
  "object.report.primaryColor": "Ataskaitos spalva",
  "object.report.postalCode": "Pašto kodas",
  "object.report.country": "Šalis",
  

  'areas.title': 'Įrenginių grupės',
  'area.title': 'Įrenginių grupė',
  'area.create.tooltip': 'Kurti Įrenginių grupę',
  'area.updated': 'Įrenginių grupė atnaujinta',
  'area.created': 'Įrenginių grupė sukurta',
  'area.removed': 'Įrenginių grupė pašalinta',
  'area.remove.error': 'Įrenginių grupės nebegalima pašalinti nes jis turi sąryšių',
  'area.filter': 'Ieškoti įrenginių grupės...',
  'area.modify.title': 'Įrenginių grupės redagavimas',
  'area.create.title': 'Įrenginių grupės kūrimas',
  'area.delete.confirm': 'Ar tikrai norite pašalinti Įrenginių grupę',
  'area.name': 'Pavadinimas',
  'area.description': 'Aprašymas',

  'equipments.title': 'Įrenginiai',
  'equipment.title': 'Įrenginys',
  'equipment.create.tooltip': 'Kurti įrenginį',
  'equipment.updated': 'Įrenginys atnaujintas',
  'equipment.created': 'Įrenginys sukurtas',
  'equipment.removed': 'Įrenginys pašalintas',
  'equipment.remove.error':
    'Įrenginio nebegalima pašalinti nes jis turi sąryšių',
  'equipment.filter': 'Ieškoti įrenginio...',
  'equipment.modify.title': 'Įrenginio redagavimas',
  'equipment.create.title': 'Įrenginio kūrimas',
  'equipment.delete.confirm': 'Ar tikrai norite pašalinti įrenginį',
  'equipment.object': 'Objektas',
  'equipment.area': 'Įrenginių grupė',
  'equipment.name': 'Pavadinimas',
  'equipment.code': 'Kodas',
  "equipment.externalCode": "Išorinis kodas",
  'equipment.description': 'Aprašymas',
  'equipment.export.success': 'Eksportas sėkmingai baigtas',
  'equipment.export.failed': 'Įrangos eksportas nepavyko',
  'equipment.export.unauthorized' : 'Vartotojas neturi leidimo',
  

  'reports.title': 'Lentelės',
  'report.modify.title': 'Lentelės redagavimas',
  'report.create.title': 'Lentelės kūrimas',
  'report.name': 'Pavadinimas',
  'report.object': 'Objektas',
  'report.indicators.select': 'Parametrų pasirinkimas',
  'report.indicator.add': 'Pridėti',
  'report.added.indicators': 'Pridėti parametrai',
  'report.indicator.aggregation.type.select': 'Agregavimo tipas',
  'report.indicator.aggregation.type.AVG': 'Vidurkis',
  'report.indicator.aggregation.type.MIN': 'Minimumas',
  'report.indicator.aggregation.type.MAX': 'Maksimumas',
  'report.indicator.aggregation.type.short.AVG': 'vid.',
  'report.indicator.aggregation.type.short.MIN': 'min.',
  'report.indicator.aggregation.type.short.MAX': 'maks.',
  'report.indicator.search': 'Parametras',
  'report.created': 'Lentelė sukurta',
  'report.updated': 'Lentelė atnaujinta',
  'report.create.tooltip': 'Kurti Lentelę',
  'report.search': 'Lentelė',
  'report.modify': 'Edit',
  'report.remove': 'Remove',
  'report.remove.confirm': 'Ar tikrai norite pašalinti lentelę?',
  'report.remove.error':
    'Lentelės negalima pašalinti, nes ji turi sąryšių (pvz. Rodikliai).',
  'report.removed': 'Lentelė sėkmingai pašalinta',
  'report.indicators.validation.error': 'Nepridėtas nė vienas parametras',
  'report.export.pdf': 'PDF',
  'report.export.excel': 'Excel',
  'report.export.excel.error': 'Nepavyko suformuoti excel',
  'report.default.name': ' Lentelė',
  'report.results.chart': 'Rezultatus vaizduoti grafike',
  'report.results.table': 'Rezultatus vaizduoti lentelėje',
  'report.upsert.error': 'Lentelės nepavyko išsaugot',
  'reports.journalsRowNo.button': 'Keisti žurnalo numeraciją',
  'report.slowLoad':
    'Duomenų generavimas užtruks, dėl pasirinkto didelio duomenų kiekio...',

  'graphs.title': 'Grafikai',
  'graph.modify.title': 'Grafiko redagavimas',
  'graph.create.title': 'Grafiko kūrimas',
  'graph.name': 'Pavadinimas',
  'graph.object': 'Objektas',
  'graph.indicators.select': 'Parametrų pasirinkimas',
  'graph.indicator.add': 'Pridėti',
  'graph.added.indicators': 'Pridėti parametrai',
  'graph.indicator.aggregation.type.select': 'Agregavimo tipas',
  'graph.indicator.aggregation.type.AVG': 'Vidurkis',
  'graph.indicator.aggregation.type.MIN': 'Minimumas',
  'graph.indicator.aggregation.type.MAX': 'Maksimumas',
  'graph.indicator.aggregation.type.short.AVG': 'vid.',
  'graph.indicator.aggregation.type.short.MIN': 'min.',
  'graph.indicator.aggregation.type.short.MAX': 'maks.',
  'graph.indicator.search': 'Parametras',
  'graph.created': 'Grafikas sukurtas',
  'graph.updated': 'Grafikas atnaujintas',
  'graph.create.tooltip': 'Kurti Grafiką',
  'graph.search': 'Grafikas',
  'graph.modify': 'Edit',
  'graph.remove': 'Remove',
  'graph.remove.confirm': 'Ar tikrai norite pašalinti grafiką?',
  'graph.remove.error':
    'Grafiko negalima pašalinti, nes jis turi sąryšių (pvz. Rodikliai).',
  'graph.removed': 'Grafikas sėkmingai pašalintas',
  'graph.indicators.validation.error': 'Nepridėtas nė vienas parametras',
  'graph.default.name': ' Grafikas',
  'graph.upsert.error': 'Grafiko nepavyko išsaugot',
  'graphs.journalsRowNo.button': 'Keisti žurnalo numeraciją',
  'graph.slowLoad':
    'Duomenų generavimas užtruks, dėl pasirinkto didelio duomenų kiekio...',
  'graphs.generate': 'Generuoti',

  'journal.rowno.error': 'Žurnale nenustatyta pradinė numeracija',
  'journal.create.title': 'Žurnalų numeracijos keitimas',
  'journal.startingRowNo': 'Naujas eilės numeris',
  'journal.fromDate': 'Pradžios data',
  'journalType.select': 'Pasirinkite žurnalą',
  'journal.created': 'Žurnalo numeracija pakeista',
  'systemType.select': 'Pasirinkite sistemą',
  'systemType.DIESEL': 'Dyzelis',
  'systemType.GAS': 'Dujos',

  'indicators.title': 'Parametrai',
  'indicator.title': 'Parametras',
  'indicator.create.tooltip': 'Kurti parametrą',
  'indicator.updated': 'Parametras atnaujintas',
  'indicator.created': 'Parametras sukurtas',
  'indicator.removed': 'Parametras pašalintas',
  'indicator.remove.error':
    'Parametro nebegalima pašalinti nes jis turi sąryšių',
  'indicator.filter': 'Ieškoti parametro...',
  'indicator.modify.title': 'Parametro redagavimas',
  'indicator.create.title': 'Parametro kūrimas',
  'indicator.delete.confirm': 'Ar tikrai norite pašalinti parametrą',
  'indicator.equipment': 'Įrenginys',
  'indicator.unit': 'Matavimo vienetas',
  'indicator.name': 'Parametro pavadinimas',
  'indicator.code': 'Parametro kodas',
  'indicator.description': 'Parametro aprašymas',
  'indicator.minLimit': 'Norma nuo',
  'indicator.maxLimit': 'Norma iki',
  'indicator.type': 'Tipas',
  'indicator.type.S': 'Paprastas',
  'indicator.type.C': 'Jungtinis',
  'compositeIndicator.title': 'Jungtiniai parametrai',
  'compositeIndicator.add': 'Pridėti',
  'compositeIndicator.remove': 'Pašalinti',
  'compositeIndicator.empty': 'Pasirinkite jungtinius parametrus',
  'compositeIndicator.duplicate': 'Jungtiniai parametrai kartojasi',

  'unknownIndicators.title': 'Nežinomi parametrai',
  'unknownIndicators.last.value': 'Paskutinė reikšmė',

  'journalNames.title': 'Žurnalai',
  'journalName.title': 'Žurnalas',
  'journalName.nonUser': 'Operatoriams draudžiama',
  'journalName.create.tooltip': 'Kurti žurnalą',
  'journalName.updated': 'Žurnalas atnaujintas',
  'journalName.created': 'Žurnalas sukurtas',
  'journalName.removed': 'Žurnalas pašalintas',
  'journalName.remove.error':
    'Žurnalo nebegalima pašalinti nes jis turi sąryšių',
  'journalName.filter': 'Ieškoti žurnalo...',
  'journalName.modify.title': 'Žurnalo redagavimas',
  'journalName.create.title': 'Žurnalo kūrimas',
  'journalName.delete.confirm': 'Ar tikrai norite pašalinti žurnalą',
  'journalName.name': 'Šablono pavadinimas',
  'journalName.object': 'Objektas',
  'journalName.type': 'Tipas',
  'journalName.type.BASIC': 'Paprastas žurnalas',
  'journalName.type.ISSUE': 'Žurnalas su būsenomis',
  'journalName.journalName': 'Žurnalo pavadinimas',
  'journalName.template': 'Šablonas',
  'journalName.clear.journalTemplate': 'Išimti žurnalo šabloną',
  'journalName.save.error': 'Įvyko klaida įrašant žurnalą',
  "journalName.repair.issueType.invalid": "Remonto žurnalas turi turėti tiksliai vieną įvykio tipą.",
  "journalName.purpose": "Žurnalo paskirtis",
  "journalName.purpose.STANDARD": "Standartinis",
  "journalName.purpose.REPAIR": "Remontai",
  "journalName.repair.type.invalid": "Remonto žurnalas turi būti žurnalas su būsenomis.",
  "journalName.repair.object.required": "Remonto žurnalas turi būti priskirtas objektui.",
  "journalName.repair.duplicate": "Šis objektas jau turi remonto žurnalą.",

  'journalTemplates.title': 'Žurnalo šablonai',
  'journalTemplate.Field.title': 'Šablonai',
  'journalTemplate.title': 'Šablonas',
  'journalTemplate.create.tooltip': 'Kurti žurnalo šabloną',
  'journalTemplate.updated': 'Žurnalo šablonas atnaujintas',
  'journalTemplate.created': 'Žurnalo šablonas sukurtas',
  'journalTemplate.removed': 'Žurnalo šablonas pašalintas',
  'journalTemplate.filter': 'Ieškoti žurnalo šablono...',
  'journalTemplate.modify.title': 'Žurnalo šablono redagavimas',
  'journalTemplate.create.title': 'Žurnalo šablono kūrimas',
  'journalTemplate.delete.confirm':
    'Ar tikrai norite pašalinti žurnalo šabloną',
  'journalTemplate.name': 'Pavadinimas',
  'journalTemplate.journalName': 'Pavadinimas',
  'journalTemplate.template': 'Šablono tekstas',

  'journalRecords.title': 'Žurnalai',
  'journalRecord.title': 'Žurnalas',
  'journalRecord.create.tooltip': 'Kurti įrašą',
  'journalRecord.updated': 'Žurnalas atnaujintas',
  'journalRecord.created': 'Žurnalas sukurtas',
  'journalRecord.removed': 'Žurnalas pašalintas',
  'journalRecord.upsert.error': 'Žurnalo nepavyko išsaugoti',
  'journalRecord.remove.error':
    'Žurnalo nebegalima pašalinti nes jis turi sąryšių',
  'journalRecord.filter': 'Ieškoti žurnalo...',
  'journalRecord.modify.title': 'Žurnalo redagavimas',
  'journalRecord.create.title': 'Įrašo kūrimas',
  'journalRecord.delete.confirm': 'Ar tikrai norite pašalinti žurnalą',
  'journalRecord.date': 'Laikas',
  'journalRecord.date.date': 'Data',
  'journalRecord.date.time': 'Laikas',
  'journalRecord.date.from': 'Data nuo',
  'journalRecord.date.to': 'Data iki',
  'journalRecord.content': 'Aprašymas',
  'journalRecord.content.filter': 'Aprašymas',
  'journalRecord.journalName': 'Žurnalo pavadinimas',
  'journalRecord.template': 'Šablonas',
  'journalRecord.user': 'Naudotojas',
  'journalRecord.createdAt': 'Sukūrimo data',

  'journalRecord.files.title': 'Failai',
  'journalRecord.file.remove': 'Pašalinti',

  'journalComments.title': 'Žurnalo Pastabos',
  'journalComment.title': 'Žurnalo pastaba',
  'journalComment.create.tooltip': 'Kurti žurnalo pastabą',
  'journalComment.updated': 'Žurnalo pastaba atnaujinta',
  'journalComment.created': 'Žurnalo pastaba sukurta',
  'journalComment.removed': 'Žurnalo pastaba pašalinta',
  'journalComment.filter': 'Ieškoti žurnalo pastabos...',
  'journalComment.modify.title': 'Žurnalo pastabos redagavimas',
  'journalComment.create.title': 'Žurnalo pastabos kūrimas',
  'journalComment.delete.confirm': 'Ar tikrai norite pašalinti žurnalo pastabą',
  'journalComment.date': 'Laikas',
  'journalComment.date.date': 'Data',
  'journalComment.date.time': 'Laikas',
  'journalComment.comment': 'Pastaba',

  'issues.title': 'Įvykiai',
  'issue.title': 'Įvykis',
  'issue.create.tooltip': 'Kurti įvykį',
  'issue.updated': 'Įvykis atnaujintas',
  'issue.created': 'Įvykis sukurtas',
  'issue.removed': 'Įvykis pašalintas',
  'issue.upsert.error': 'Įvykio nepavyko išsaugoti',
  'issue.remove.error': 'Įvykio nebegalima pašalinti nes jis turi sąryšių',
  'issue.filter': 'Ieškoti įvykio...',
  'issue.modify.title': 'Įvykio redagavimas',
  'issue.create.title': 'Įvykio kūrimas',
  'issue.delete.confirm': 'Ar tikrai norite pašalinti įvykį',
  'issue.date': 'Laikas',
  'issue.date.date': 'Data',
  'issue.date.time': 'Laikas',
  'issue.date.from': 'Data nuo',
  'issue.date.to': 'Data iki',
  'issue.name': 'Pavadinimas',
  'issue.content': 'Aprašymas',
  'issue.user': 'Užregistravęs naudotojas',
  'issue.responsible': 'Atsakingas',
  'issue.content.filter': 'Įvykio aprašymas',
  'issue.journalName': 'Įvykio pavadinimas',
  'issues.date': 'Data',
  'issues.name': 'Pavadinimas',
  'issues.content': 'Aprašymas',
  'issues.equipment.name': 'Įrenginys',
  'issue.user.name': 'Naudotojo vardas',
  'issue.user.surname': 'Naudotojo pavardė',
  'issue.responsible.name': 'Atsakingo vardas',
  'issue.responsible.surname': 'Atsakingo pavardė',
  'issue.issueState.name': 'Būsena',
  'issue.issueType.name': 'Tipas',
  'issue.issueFiles.fileName': 'Failo pavadinimas',
  'issue.issueTasks.task': 'Užduotis',
  'issue.issueTasks.responsible': 'Vykdytojas',
  'issue.issueTasks.issueState': 'Vykdymo būsena',
  'issue.issueTasks.issueState.name': 'Vykdymo būsena',
  'issue.area': 'Įrenginių grupė',
  'issue.equipment': 'Įrenginys',
  'issue.exportPdf': 'Atsisiųsti PDF',

  'issueFiles.title': 'Failai',
  'issueFile.delete.confirm': 'Ar tikrai norite pašalinti failą',
  'issueFile.removed': 'Failas pašalintas',
  'issueFile.created': 'Failas pridėtas',

  'issueTasks.title': 'Vykdytojai',
  'issueTask.delete.confirm': 'Ar tikrai norite pašalinti vykdytoją',
  'issueTask.removed': 'Vykdytojas pašalintas',
  'issueTask.created': 'Vykdytojas pridėtas',
  'issueTask.task': 'Užduotis',
  'issueTask.issueState.updated': 'Užduoties būsena pakeista',
  'issueTask.responsible': 'Vykdytojas',

  'issueItems.title': 'Panaudotos sandėlio detalės',
  'issueItem.delete.confirm': 'Ar tikrai norite pašalinti sandėlio detalę?',
  'issueItem.amount': 'Kiekis',
  'issueItem.replenished': 'Sandėlio detalė grąžinta',
  'issueItem.reduced': 'Sandėlio detalė paimta',
  'issueItem.date': 'Data',

  'issueComments.title': 'Įvykio pastabos',
  'issueComment.title': 'Įvykio pastaba',
  'issueComment.create.tooltip': 'Kurti įvykio pastabą',
  'issueComment.updated': 'Įvykio pastaba atnaujinta',
  'issueComment.created': 'Įvykio pastaba sukurta',
  'issueComment.removed': 'Įvykio pastaba pašalinta',
  'issueComment.filter': 'Ieškoti įvykio pastabos...',
  'issueComment.modify.title': 'Įvykio pastabos redagavimas',
  'issueComment.create.title': 'Įvykio pastabos kūrimas',
  'issueComment.delete.confirm': 'Ar tikrai norite pašalinti įvykio pastabą',
  'issueComment.date': 'Laikas',
  'issueComment.date.date': 'Data',
  'issueComment.date.time': 'Laikas',
  'issueComment.comment': 'Pastaba',

  'issueTypes.title': 'Įvykių tipai',
  'issueType.title': 'Įvykio tipas',
  'issueType.create.tooltip': 'Kurti įvykių tipą',
  'issueType.updated': 'Įvykio tipas atnaujintas',
  'issueType.created': 'Įvykio tipas sukurtas',
  'issueType.removed': 'Įvykio tipas pašalintas',
  'issueType.remove.error':
    'Įvykio tipo nebegalima pašalinti nes jis turi sąryšių',
  'issueType.filter': 'Ieškoti įvykio tipo...',
  'issueType.modify.title': 'Įvykio tipo redagavimas',
  'issueType.create.title': 'Įvykio tipo kūrimas',
  'issueType.delete.confirm': 'Ar tikrai norite pašalinti įvykio tipą',
  'issueType.name': 'Įvykio tipo pavadinimas',
  'issueType.issueStates.removed': 'Būsena sėkmingai pašalinta',
  'issueType.issueStates.added': 'Būsena sėkmingai pridėta',

  'issueStates.title': 'Įvykių būsenos',
  'issueState.title': 'Įvykio būsena',
  'issueState.create.tooltip': 'Kurti įvykio būseną',
  'issueState.updated': 'Įvykio būsena atnaujinta',
  'issueState.created': 'Įvykio būsena sukurta',
  'issueState.removed': 'Įvykio būsena pašalinta',
  'issueState.remove.error':
    'Įvykio būsenos nebegalima pašalinti nes ji turi sąryšių',
  'issueState.filter': 'Ieškoti įvykio būsenos...',
  'issueState.modify.title': 'Įvykio būsenos redagavimas',
  'issueState.create.title': 'Įvykio būsenos kūrimas',
  'issueState.delete.confirm': 'Ar  tikrai norite pašalinti įvykio būseną',
  'issueState.name': 'Pavadinimas',
  'issueState.issueTypes.removed': 'Tipas sėkmingai pašalintas',
  'issueState.issueTypes.added': 'Tipas sėkmingai pridėtas',
  'issueState.color': 'Spalva',
  'issueState.color.#e57373': 'Raudona',
  'issueState.color.#64b5f6': 'Mėlyna',
  'issueState.color.#81c784': 'Žalia',
  'issueState.color.#dce775': 'Geltona',
  'issueState.color.#ff8a65': 'Oranžinė',
  'issueState.color.#a1887f': 'Ruda',
  'issueState.color.#e0e0e0': 'Pilka',

  'issueTypeState.issueType.filter': 'Pasirinkite įvykio tipą',
  'issueTypeState.issueState.filter': 'Pasirinkite įvykio būseną',

  'issueWorkAct.title': 'Informacija ataskaitai',
  'issueWorkAct.workBy': 'Darbus atliko',
  'issueWorkAct.description': 'Darbo aprašymas',
  'issueWorkAct.equipmentWork': 'Įrenginio darbo valandos',
  'issueWorkAct.updated': 'Ataskaitos infroacija atnaujinta',

  // material form generic
  materials: 'Produktai',
  'materials.title': 'Produktai',
  'material.title': 'Produktas',
  'material.delete.confirm': 'Ar tikrai norite pašalinti produktą',
  'material.updated': 'Produktas atnaujintas',
  'material.removed': 'Produktas pašalintas',
  'material.created': 'Produktas sukurtas',
  'material.filter': 'Ieškoti produkto...',
  'material.select': 'Produktas',
  'material.modify.title': 'Produktas',
  'material.create.title': 'Produkto kūrimas',
  'material.create.tooltip': 'Kurti produktą',
  // material form specific
  'material.type': 'Produktas',
  'material.description': 'Aprašymas',
  'material.shortDescription': 'Trumpas aprašymas',
  'material.classificator': 'Klasifikatorius',
  'material.tarrifGroupCode': 'Tarifinė grupė',
  'material.materialType': 'Produkto rūšis',
  'material.name.unique': 'Produkto pavadinimas turi būti unikalus',
  'refresh.page': 'Perkrauti',
  'version.mismatch': 'Sistemos versijos atnaujinimas',
  'click.refresh.button':
    'Išleista nauja sistemos versija. ' +
    'Paspauskite mygtuką "Perkrauti", kad naudotumėtės nauja versija.',

  // driver form generic
  drivers: 'Vairuotojai',
  'drivers.title': 'Vairuotojai',
  'driver.title': 'Vairuotojas',
  'driver.create.tooltip': 'Kurti Vairuotoją',
  'driver.updated': 'Vairuotojas atnaujintas',
  'driver.created': 'Vairuotojas sukurtas',
  'driver.removed': 'Vairuotojas pašalintas',
  'driver.filter': 'Ieškoti vairuotojo...',
  'driver.modify.title': 'Vairuotojo redagavimas',
  'driver.create.title': 'Vairuotojo kūrimas',
  'driver.delete.confirm': 'Ar tikrai norite pašalinti vairuotoją',
  // driver form specific
  'driver.fullName': 'Vairuotojo vardas pavardė',
  'driver.adrNo': 'ADR Nr.',
  'driver.adrDate': 'ADR data',
  'create.driver.unique.error': 'Toks vairuotojas jau egsiztuoja',
  'create.operator.unique.error': 'Toks operatorius jau egsiztuoja',

  // operator form generic
  operators: 'Scada operatoriai',
  'operators.title': 'Scada operatoriai',
  'operator.title': 'Scada operatorius',
  'operator.create.tooltip': 'Kurti Vairuotoją',
  'operator.updated': 'Scada operatorius atnaujintas',
  'operator.created': 'Scada operatorius sukurtas',
  'operator.removed': 'Scada operatorius pašalintas',
  'operator.filter': 'Ieškoti scada operatoriaus...',
  'operator.modify.title': 'Scada operatoriaus redagavimas',
  'operator.create.title': 'Scada operatoriaus kūrimas',
  'operator.delete.confirm': 'Ar tikrai norite pašalinti scada operatorių',
  // operator form specific
  'operator.fullName': 'Scada operatoriaus vardas pavardė',
  'operator.adrNo': 'Scada operatoriaus ADR numeris',
  'operator.adrDate': 'Scada operatoriaus ADR galiojimo data',

  // company form generic
  companies: 'Įmonės',
  'companies.title': 'Įmonės',
  'company.title': 'Įmonė',
  'company.create.tooltip': 'Kurti Įmonę',
  'company.updated': 'Įmonė išsaugota',
  'company.created': 'Įmonė sukurta',
  'company.removed': 'Įmonė pašalinta',
  'company.filter': 'Ieškoti įmonės ...',
  'company.modify.title': 'Įmonės redagavimas',
  'company.create.title': 'Įmonės kūrimas',
  'company.delete.confirm': 'Ar tikrai norite pašalinti įmonę ?',
  // company form specific
  'company.name': 'Pavadinimas',
  'company.address': 'Adresas',
  'company.vatCode': 'PVM kodas',
  'company.country': 'Valstybė',
  'company.companyCode': 'Įmonės kodas',
  'company.exciseWhNo': 'Akcizinio sandėlio Nr.',
  'company.additionalInformation': 'Papildoma informacija',
  'company.companyCode.unique': 'Įmonės kodas turi būti unikalus',
  'company.code.unique': 'Įmonės kodas turi būti unikalus',
  'country.select': 'Valstybė',
  'company.whClient': 'Sandėlio klientas',
  'company.select': 'Įmonė',
  'company.select.sender': 'Ieškoti siuntėjo',
  'company.select.receiver': 'Ieškoti gavėjo',
  'company.whClient.select': 'Sandėlio klientas',

  // tank form generic
  tanks: 'Talpyklos',
  'tanks.title': 'Talpyklos',
  'tank.create.tooltip': 'Sukurti talpyklą',
  'tank.updated': 'Talpykla atnaujinta',
  'tank.created': 'Talpykla sukurta',
  'tank.removed': 'Talpykla pašalinta',
  'tank.filter': 'Ieškoti talpyklos...',
  'tank.modify.title': 'Talpyklos redagavimas',
  'tank.create.title': 'Talpyklos kūrimas',
  'tank.delete.confirm': 'Ar tikrai norite pašalinti talpyklą ?',
  // tank form specific
  'tank.name': 'Talpyklos pavadinimas',
  'tank.capacity.ltr': 'Talpa litrais (l)',
  'tank.capacity.kg': 'Talpa kilogramais (kg)',
  'tank.material': 'Produktas',
  'tank.name.unique': 'Talpyklos pavadinimas turi būti unikalus',

  // transport form generic
  transports: 'Transporto priemonės',
  'transports.title': 'Transporto priemonės',
  'transport.title': 'Transporto priemonė',
  'transport.create.tooltip': 'Kurti Transporto priemonę',
  'transport.updated': 'transporto priemonė atnaujinta',
  'transport.created': 'Transporto priemonė sukurta',
  'transport.removed': 'Transporto priemonė pašalinta',
  'transport.filter': 'Ieškoti transporto priemonės',
  'transport.edit.title': 'Transporto priemonės redagavimas',
  'transport.create.title': 'Transporto priemonės kūrimas',
  'transport.delete.confirm': 'Ar tikrai norite pašalinti transporto priemonę',
  // transport form specific
  'transportType.select': 'Tipas',
  'transport.name.unique': 'Transporto priemonės numeris turi būti unikalus',
  'transports.description': 'Apibūdinimas',
  'transports.brand': 'Markė',
  'transports.model': 'Modelis',
  'transports.adrNo': 'ADR numeris',
  'transports.identificationNo': 'Numeris',
  'transports.adrDate': 'ADR galiojimo data',
  'transports.segments': 'Segmentų talpos',
  'transports.segmentNo': 'Segmento Nr.',
  'transports.capacityLtr': 'Segmento talpa, l',
  'transport.segment.add': 'Pridėti',
  'transport.segment.remove': 'Pašalinti',
  'transport.identificationNo': 'Numeris',
  'transport.type': 'Tipas',
  'transport.used.in.order':
    'Negalima ištrinti, nes transporto priemonė panaudota užsakyme',

  // Lithoil order tables
  'order.report.remove.error': 'Lentelės negalima pašalinti',
  'order.sender.name': 'Siuntėjo Pavadinimas',
  'order.sender.address': 'Siuntėjo Adresas',
  'order.sender.vatCode': 'Siuntėjo PVM kodas',
  'order.sender.companyCode': 'Siuntėjo Įmonės kodas',
  'order.sender.exciseWhNo': 'Siuntėjo Akcizinio sandėlio Nr',
  'order.sender.additionalInformation': 'Siuntėjo Papildoma informacija',
  'order.receiver.name': 'Gavėjo Pavadinimas',
  'order.receiver.address': 'Gavėjo Adresas',
  'order.receiver.vatCode': 'Gavėjo PVM kodas',
  'order.receiver.companyCode': 'Gavėjo Įmonės kodas',
  'order.receiver.exciseWhNo': 'Gavėjo Akcizinio sandėlio Nr',
  'order.receiver.additionalInformation': 'Gavėjo Papildoma informacija',
  'order.carrier.name': 'Vežėjo Pavadinimas',
  'order.carrier.address': 'Vežėjo Adresas',
  'order.carrier.vatCode': 'Vežėjo PVM kodas',
  'order.carrier.companyCode': 'Vežėjo Įmonės kodas',
  'order.carrier.exciseWhNo': 'Vežėjo Akcizinio sandėlio Nr',
  'order.carrier.additionalInformation': 'Vežėjo Papildoma informacija',
  'order.delivery.name': 'Iškrovimo vietos Pavadinimas',
  'order.delivery.address': 'Iškrovimo vietos Adresas',
  'order.delivery.vatCode': 'Iškrovimo vietos PVM kodas',
  'order.delivery.companyCode': 'Iškrovimo vietos Įmonės kodas',
  'order.delivery.exciseWhNo': 'Iškrovimo vietos Akcizinio sandėlio Nr',
  'order.delivery.additionalInformation':
    'Iškrovimo vietos Papildoma informacija',
  'order.seller.name': 'Pardavėjo Pavadinimas',
  'order.seller.address': 'Pardavėjo Adresas',
  'order.seller.vatCode': 'Pardavėjo PVM kodas',
  'order.seller.companyCode': 'Pardavėjo Įmonės kodas',
  'order.seller.exciseWhNo': 'Pardavėjo Akcizinio sandėlio Nr',
  'order.seller.additionalInformation': 'Pardavėjo Papildoma informacija',
  'order.buyer.name': 'Pirkėjo Pavadinimas',
  'order.buyer.address': 'Pirkėjo Adresas',
  'order.buyer.vatCode': 'Pirkėjo PVM kodas',
  'order.buyer.companyCode': 'Pirkėjo Įmonės kodas',
  'order.buyer.exciseWhNo': 'Pirkėjo Akcizinio sandėlio Nr',
  'order.buyer.additionalInformation': 'Pirkėjo Papildoma informacija',
  'order.vehicle.identificationNo': 'Mašinos numeris',
  'order.vehicle.adrNo': 'Mašinos ADR nr',
  'order.vehicle.adrDate': 'Mašinos ADR data',
  'order.trailer.identificationNo': 'Priekabos numeris',
  'order.trailer.adrNo': 'Priekabos ADR nr',
  'order.trailer.adrDate': 'Priekabos ADR data',
  'order.cmrNo': 'CMR numeris',
  'order.cmrSerialNo': 'CMR serija',
  'order.eAd': 'eAD',
  'order.exciseTariff': 'Akcizo tarifas',
  'order.unloadDate': 'Atkrovimo data',
  'order.orderProducts.material.type': 'Produktas',
  'order.orderProducts.material.classificator': 'Produkto klasifikatorius',
  'order.orderProducts.material.tarrifGroupCode': 'Produkto tarifinė grupė',
  'order.orderProducts.orderProductComponents.value': 'Komponento reikšmė',
  'order.orderProducts.orderProductComponents.value.material': 'Komponentas',
  'order.transaction.eventDateTime': 'Data laikas',
  'order.transaction.meterId': 'Kolonėlė',
  'order.transaction.temperature': 'Temperatūra',
  'order.transaction.density': 'Tankis',
  'order.transaction.density15': 'Tankis 15C',
  'order.transaction.fuelQuantityKg': 'Svoris kg',
  'order.transaction.fuelQuantityLtr': 'Litrai',
  'order.transaction.fuelQuantityLtr15C': 'Litrai 15c',
  'order.transaction.compBQuantityKg': 'RRME Svoris kg',
  'order.transaction.compBQuantityLtr': 'RRME Litrai',
  'order.transaction.compBQuantityLtr15C': 'RRME Litrai 15c',
  'order.transaction.totalKg': 'Bendras Svoris kg',
  'order.transaction.totalLtr': 'Bendras Litrai',
  'order.transaction.totalLtr15C': 'Bendras Litrai 15c',
  'order.orderOperator.fullName': 'Operatorius',
  'order.orderDriver.fullName': 'Vairuotojas',
  'order.orderDriver.adrNo': 'Vairuotojo ADR nr',
  'order.orderDriver.adrDate': 'Vairuotojo ADR data',

  'unloadOrder.eventDateTime': 'Atkrovimo data laikas',
  'unloadOrder.eAd': 'eAD',
  'unloadOrder.sender.name': 'Siuntėjo Pavadinimas',
  'unloadOrder.sender.address': 'Siuntėjo Adresas',
  'unloadOrder.sender.vatCode': 'Siuntėjo PVM kodas',
  'unloadOrder.sender.companyCode': 'Siuntėjo Įmonės kodas',
  'unloadOrder.sender.exciseWhNo': 'Siuntėjo Akcizinio sandėlio Nr',
  'unloadOrder.receiver.name': 'Gavėjo Pavadinimas',
  'unloadOrder.receiver.address': 'Gavėjo Adresas',
  'unloadOrder.receiver.vatCode': 'Gavėjo PVM kodas',
  'unloadOrder.receiver.companyCode': 'Gavėjo Įmonės kodas',
  'unloadOrder.receiver.additionalInfo': 'Gavėjo Papildoma informacija',
  'unloadOrder.product': 'Produktas',
  'unloadOrder.cmr': 'CMR',
  'unloadOrder.weight': 'Svoris kg',
  'unloadOrder.volume': 'Litrai',
  'unloadOrder.volume15C': 'Litrai 15C',
  'unloadOrder.density15C': 'Tankis 15C',
  'unloadOrder.temperature': 'Temperatūra',
  'unloadOrder.wagon.weight': 'Vagono Svoris kg',
  'unloadOrder.wagon.volume': 'Vagono Litrai',
  'unloadOrder.wagon.volume15C': 'Vagono Litrai 15C',
  'unloadOrder.wagon.density15C': 'Vagono Tankis 15C',
  'unloadOrder.wagon.smgs': 'SMGS',
  'unloadOrder.wagon.tanker': 'Vagono nr',
  'unloadOrder.trailer.identificationNo': 'Priekabos nr',
  'unloadOrder.vehicle.identificationNo': 'Mašinos nr',

  // order form generic
  orders: 'Išlaidavimas',
  'orders.title': 'Užsakymai',
  'order.title': 'Užsakymas',
  'order.delete.confirm': 'Ar tikrai norite pašalinti užsakymą',
  'order.updated': 'Užsakymas atnaujintas',
  'order.removed': 'Užsakymas pašalintas',
  'order.created': 'Užsakymas sukurtas',
  'order.filter': 'Ieškoti užsakymo...',
  'order.modify.title': 'Užsakymo redagavimas',
  'order.view.title.begin': 'Užsakymo ',
  'order.view.title.end': 'peržiūra',
  'order.copy.title': 'Užsakymo kūrimas',
  'order.create.title': 'Užsakymo kūrimas',
  'order.create.tooltip': 'Kurti užsakymą',
  // order form specific
  'order.save.failed': 'Nepavyko išsaugoti užsakymo',
  'order.orderNo.unique': 'Užsakymo numeris turi būti unikalus',
  'order.cmrNo.unique': 'CMR numeris turi būti unikalus',
  'order.type': 'Užsakymas',
  'order.find.no': 'Numeris',
  'order.date.from': 'Data nuo',
  'order.date.to': 'Data iki',
  'order.date': 'Atkrovimo data',
  'order.mainOrderNo': 'Bendras Nr.',
  'order.orderDetailCMR.cmrSerialNo': 'CMR serija',
  'order.orderDetailCMR.cmrNo': 'CMR numeris',
  'order.orderNo': 'Užsakymo numeris',
  'order.orderInfo': 'Užsakymo informacija',
  'order.product': 'Produktas ',
  'order.products': 'Produktai ',
  'order.product.find': 'Ieškoti...',
  'order.eAD': 'eAD ',
  'order.exciseTarrif': 'Akcizo tarifas  ',
  'order.qualityCertificateNo': 'Kokybės sertifikato Nr.  ',
  'order.qualityCertificateDate': 'Kokybės sert. data',
  'order.seals': 'Plombos  ',
  'order.technicalPour': 'Techninis pylimas',
  'order.rrmeAmmountPercent': 'RRME kiekis, %',
  'order.redDyeRation': 'Raud. dažai, PPM',
  'order.greenDyeRatio': 'Žali dažai, PPM',
  'order.rrmeAmmountLiter': 'RRME kiekis, l',
  'order.redDyeMg': 'Raudoni dažai, mg',
  'order.greenDyeMg': 'Žali dažai, mg',
  'order.productAmmountLtr': 'Produkto kiekis, l',
  'order.seller.remove': 'pašalinti pardavėją',
  'order.buyer.remove': 'pašalinti pirkėją',
  'order.sender.remove': 'pašalinti siuntėją',
  'order.receiver.remove': 'pašalinti gavėją',
  'order.carrier.remove': 'pašalinti vežėją',
  'order.delivery.remove': 'pašalinti pristatymo vietą',
  'order.sender.find': 'Ieškoti siuntėjo...',
  'order.sender': 'Siuntėjas',
  'order.receiver.find': 'Ieškoti gavėjo...',
  'order.receiver': 'Gavėjas',
  'order.receivers': 'Gavėjai',
  'order.delivery.find': 'Ieškoti...',
  'order.delivery': 'Iškrovimo vieta',
  'order.carrier.find': 'Ieškoti vežėjo...',
  'order.carrier': 'Vežėjas',
  'order.buyer.find': 'Ieškoti Pirkėjo...',
  'order.buyer': 'Pirkėjas',
  'order.seller.find': 'Ieškoti Pardavėjo...',
  'order.seller': 'Pardavėjas',
  'order.driver.find': 'Ieškoti vairuotojo...',
  'order.driver': 'Vairuotojas',
  'order.operator.find': 'Ieškoti Scada operatoriaus...',
  'order.operator': 'Scada operatorius',
  'order.clear.driver': 'Pašalinti vairuotoją',
  'order.clear.operator': 'Pašalinti operatorių',
  'order.clear.sender': 'Pašalinti siuntėją',
  'order.clear.receiver': 'Pašalinti gavėją',
  'order.clear.carrier': 'Pašalinti vežėją',
  'order.clear.delivery': 'Pašalinti iškrovimo vietą',
  'order.clear.buyer': 'Pašalinti pirkėją',
  'order.clear.seller': 'Pašalinti pardavėją',
  'order.clear.vehicle': 'Pašalinti mašiną',
  'order.clear.trailer': 'Pašalinti priekabą',
  'order.clear.product': 'Pašalinti produktą',
  'driver.adrDate.not.valid': 'Vairuotojo ADR data negaliojanti',
  'order.vehicle': 'Mašina',
  'order.vehicle.find': 'Ieškoti...',
  'order.trailer': 'Priekaba',
  'order.trailer.find': 'Ieškoti...',
  'order.island': 'Salelė',
  'order.invoiceNo': 'SF Nr.',
  'order.transport.segment': 'Segmentai',
  'order.transport.segment.quantityLtr15C': 'Kiekis, l',
  'order.transport.segment.capacityLtr': 'Talpa, l',
  'order.transport.segment.segmentNo': 'Seg. Nr.',
  'order.sum.order': 'Užsakyme',
  'order.sum.product': 'Produktas',
  'order.sum.vehicle': 'Mašina',
  'order.sum.trailer': 'Priekaba',
  'order.sum.full': 'Viso',
  'order.sum': 'Kiekio išskirstymas',
  'order.sum.title': 'Viso: ',
  'order.transports.adrNo': 'ADR Nr',
  'order.transports.adrDate': 'ADR data',
  'order.searchButton': 'Ieškoti',
  'order.change.history': 'Pakeitimų istorija',
  'order.change.history.block': 'Blokas',
  'order.change.history.field': 'Laukas',
  'order.change.history.oldValue': 'Sena reikšmė',
  'order.change.history.newValue': 'Nauja reikšmė',
  'order.change.history.comment': 'Komentaras: ',
  'order.list.date': 'Atkrovimo data',
  'order.list.mainOrderNo': 'Bendras užsakymo Nr.',
  'order.list.cmrNo': 'CMR numeris',
  'order.driver.fullName': 'Vardas pavardė',
  'order.driver.adrNo': 'ADR Nr.',
  'order.driver.adrDate': 'ADR data',
  'order.operator.fullName': 'Vardas pavardė',
  'order.remove.error.loaded':
    'Negalima ištrinti, nes užsakymo pylimas įvykdytas',
  'order.edit.comment.dialog.title': 'Komentaras',
  'order.edit.comment.field.label': 'Įveskite užsakymo keitimo priežastį',
  'order.item.create': 'Kurti naują',
  'order.technicalPour.finish': 'Baigti techninį pylimą',

  'order.change.history.orderCompanies.1': 'Siuntėjas',
  'order.change.history.orderCompanies.2': 'Gavėjas',
  'order.change.history.orderCompanies.3': 'Vežėjas',
  'order.change.history.orderCompanies.4': 'Iškrovimo vieta',
  'order.change.history.orderCompanies.5': 'Pardavėjas',
  'order.change.history.orderCompanies.6': 'Pirkėjas',
  'order.change.history.orderDrivers': 'Vairuotojas',
  'order.change.history.orderTransports.1': 'Mašina',
  'order.change.history.orderTransports.2': 'Priekaba',
  'order.change.history.orderTransports.4': 'Puspriekabė',
  'order.change.history.orderDetails': 'Priekabos segmentai',
  'order.change.history.orderDetails.quantityLtr15C': 'Kiekis',
  'order.change.history.orderDetails.orderProductId': 'Produktas',
  'order.change.history.orderDetails.orderTransportSegmentId': 'Seg. Nr.',
  'order.change.history.orderProducts': 'Produktas',
  'order.change.history.orderProducts.productId': 'Produktas',
  'order.change.history.orderProducts.qtyLtr': 'Kiekis',
  'order.change.history.orders': 'Užsakymo informacija',
  'order.change.history.orderCompanies': 'Įmonė',
  'order.change.history.orderCompanies.name': 'Pavadinimas',
  'order.change.history.orderCompanies.address': 'Adresas',
  'order.change.history.orderCompanies.vatCode': 'PVM Kodas',
  'order.change.history.orderCompanies.companyCode': 'Įmonės kodas',
  'order.change.history.orderTransports.identificationNo': 'Numeris',
  'order.change.history.orderTransports.brand': 'Markė',
  'order.change.history.orderTransports.adrDate': 'ADR data',
  'order.change.history.orderTransports.adrNo': 'ADR Nr',
  'order.change.history.orderTransportSegments': 'Segmentų talpos',
  'order.change.history.orderTransportSegments.segmentNo': 'Seg. Nr.',
  'order.change.history.orderTransportSegments.capacityLtr': 'Talpa, l',
  'order.change.history.orderTransportSegments.capacityKg': 'Svoris, kg',
  'order.change.history.orderTransportSegments.orderTransportId': 'Seg. Id',
  'order.change.history.orderDrivers.fullName': 'Vardas pavardė',
  'order.change.history.orderDrivers.adrNo': 'ADR numeris',
  'order.change.history.orderDrivers.adrDate': 'ADR galiojimo data',
  'order.change.history.orders.orderNo': 'Užsakymo numeris',
  'order.change.history.orders.mainOrderNo': 'Bendras Nr.',
  'order.change.history.orders.cmrNo': 'CMR numeris',
  'order.change.history.orders.cmrSerialNo': 'Serija',
  'order.change.history.orders.eAd': 'eAD',
  'order.change.history.orders.seals': 'Plombos',
  'order.change.history.orders.exciseTariff': 'Akcizo tarifas',
  'order.change.history.orders.qualityCertificateNo': 'Kokybės sertifikato Nr.',
  'order.change.history.orders.qualityCertificateDate':
    'Kokybės sertifikato data',
  'order.change.history.orders.unloadDate': 'Atkrovimo data',
  'order.change.history.orders.islandNo': 'Salelė',
  'order.change.history.orders.invoiceNo': 'SF Nr.',
  'order.change.history.orders.technicalPour': 'Techninis pylimas',
  'order.change.history.orderProductComponents': 'Produkto komponentas',
  'order.change.history.orderProductComponents.value': 'Reikšmė',
  'order.change.history.orderProductComponents.orderProductId': 'Produktas',
  'order.change.history.orderProductComponents.componentId': 'Komponentas',
  'order.receipt.title': 'Kvitas',
  'order.receipt.print': 'Spausdinti kvitą',
  'order.receipt.island': 'Kolonėlės nr.',
  'order.receipt.orderNo': 'Užsakymo nr.',
  'order.receipt.cmrNo': 'CMR',
  'order.receipt.transport': 'Mašina / Priekaba',
  'order.receipt.temperature': 'Temperatūra',
  'order.receipt.density': 'Tankis',
  'order.receipt.density15C': 'Tankis +15C',
  'order.receipt.weight': 'Kilogramai',
  'order.receipt.volume': 'Litrai',
  'order.receipt.volume15C': 'Litrai +15C',
  'order.receipt.diesel': 'Diesel',
  'order.receipt.rrme': 'RRME',
  'order.receipt.rrme%': 'Bio %',
  'order.receipt.total': 'Bendras',
  'order.receipt.seals': 'Plombos',
  'order.receipt.snd': 'SND',
  'order.edit.tooltip': 'Redaguoti užsakymą',
  'order.cmrRrme.print': 'Spausdinti užsakymo važtaraštį',
  'order.cmrRrme.print.noData': 'Dokumento suformavimui nepakanka duomenų',
  'order.cmr.print': 'Spausdinti užsakymo CMR',
  'order.transactions.eAd': 'eAD',
  'order.transactions.weight': 'Kilogramai',
  'order.transactions.volume': 'Litrai',
  'order.transactions.volume15C': 'Litrai 15C',

  'vehicle.adrDate.not.valid': 'Transporto priemonės ADR data negaliojanti',
  'trailer.adrDate.not.valid': 'Priekabos ADR data negaliojanti',

  "clients":'Klientai',
  "clients.title":"Klientai",
  "client.dataLakeId":"Datalake ID",
  "client.isDataLake":"Klientas Datalake",
  "client.namespace":"Kliento erdvė",
  "client.name":"Kliento pavadinimas",
  "client.languages":"Kliento kalbos",
  "client.addons":"Kliento prieigos",
  "client.modify.title":"Kliento koregavimas",
  'client.create.title': 'Kliento kūrimas',
  "client.title":"Klientas",
  'client.created': 'Klientas sukurtas',
  'client.updated': 'Klientas pakeistas',
  'client.removed': 'Klientas pašalintas',
  'client.remove.error':
  'Kliento nebegalima pašalinti nes jis turi sąryšių',
  'client.delete.confirm': 'Ar tikrai norite pašalinti klientą?',
  'client.filter':"Ieškoti kliento...",


  'users': 'Naudotojai',
  'user.filter': 'Ieškoti naudotojo...',
  'users.title': 'Naudotojai',
  'user.title': 'Naudotojas',
  'user.profile': 'Mano profilis',
  'user.modify.title': 'Naudotojo redagavimas',
  'user.create.title': 'Naudotojo kūrimas',
  'users.create.tooltip': 'Įvesti naudotoją',
  'user.created': 'Naudotojas sukurtas',
  'user.updated': 'Naudotojas pakeistas',
  'user.removed': 'Naudotojas pašalintas',
  'user.remove.error': 'Naudotojo nebegalima pašalinti nes jis turi sąryšių',
  'user.name': 'Vardas',
  'user.surname': 'Pavardė',
  'user.role': 'Rolė',
  'user.role.ADMIN': 'Administratorius',
  'user.role.USER': 'Naudotojas',
  'user.role.OPERATOR': 'Operatorius',
  'user.role.undefined': 'Nenurodyta',
  'user.email': 'E-paštas',
  'user.email.unique': 'E-paštas turi būti unikalus',
  'user.username': 'Naudotojo vardas',
  'user.username.unique': 'Naudotojo vardas turi būti unikalus',
  'user.password': 'Naudotojo slaptažodis',
  'user.notify': 'Siųsti priminimus',
  'user.delete.confirm': 'Ar tikrai norite pašalinti naudotoją?',
  'user.language.select': 'Kalba',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Redaguoti naudotoją',
  'user.role.select': 'Rolė',
  'user.view.change.password': 'Keisti slaptažodį',
  'user.password.change.title': 'Slaptažodžio keitimas',
  'user.password.old': 'Senas slaptažodis',
  'user.password.new1': 'Naujas slaptažodis',
  'user.password.new2': 'Pakartokite naują slaptažodį',
  'user.password.change.mismatch': 'Nesutampa naujai įvesti slaptažodžiai',
  'user.password.changed': 'Slaptažodis pakeistas.',
  'user.password.change.failed':
    'Slaptažodžio pakeisti nepavyko. Nurodytas neteisingas slaptažodis.',
  'user.haveNoRights':
    'Puslapis nerastas arba jūsų vartotojui nesuteiktos reikiamos teisės',
  'user.objects': 'Objektai',
  'user.object': 'Objektas',
  'user.permissions':'Prieigos prie ataskaitų',
  "user.isDataLake":"Vartotojas Datalake",
  "user.access":"Leidimai vartotojui",
  'userObject.delete.confirm': 'Ar tikrai norite pašalinti objektą?',
  'userObject.created': 'Objektas priskirtas',
  'userObject.removed': 'Objektas pašalintas',

  dashboard: 'Grafikas',
  'dashboard.generate': 'Generuoti',
  'dashboard.saveAsImage': 'Paveiksliukas',
  'dashboard.exportToExcel': 'Excel',
  'dashboard.dataZoom': 'Priartinti',
  'dashboard.dataZoomReset': 'Gražinti praeitą vaizdą',
  'dashboard.restore': 'Atstatyti pradinį vaizdą',
  'dashboard.noData': 'Nėra duomenų',
  'dashboard.data.title': 'Grafikas',
  'dashboard.data.dateFrom': 'Laikotarpis nuo (imtinai)',
  'dashboard.data.dateTo': 'Laikotarpis iki (imtinai)',
  'dashboard.data.unit': 'Matavimo vienetas',
  'dashboard.data.unit.WEIGHT': 'Svoris, t',
  'dashboard.data.unit.VOLUME': 'Tūris, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Tūris prie 15°C, m3',
  'dashboard.data.unit.WEIGHT.short': 't',
  'dashboard.data.unit.VOLUME.short': 'm3',
  'dashboard.data.unit.VOLUME_AT_15C.short': 'm3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Laikas',
  'dashboard.data.official': 'Buhalterija',
  'dashboard.data.fact': 'Faktinis',
  'dashboard.data.factFrom': 'Fakto paklaida nuo',
  'dashboard.data.factTo': 'Paklaidos dydis',
  'dashboard.data.factPart1': 'Talpykla1',
  'dashboard.data.factPart2': 'Talpykla2',
  'dashboard.data.factPart3': 'Talpykla3',
  'dashboard.data.factPart4': 'Talpykla4',
  'dashboard.data.factPart5': 'Talpykla5',
  'dashboard.data.factPart6': 'Talpykla6',
  'dashboard.data.factPart7': 'Talpykla7',
  'dashboard.data.factPart8': 'Talpykla8',
  'dashboard.data.diff': 'Skirtumas',
  'dashboard.data.counter': 'Skaitiklis',
  'dashboard.data.counterDiff': 'Skaitiklio skirtumas',
  administration: 'Administravimas',
  reports: 'Ataskaitos',
  journals: 'Žurnalai',
  'reports.generate': 'Generuoti',
  'reports.export': 'Eksportuoti',
  'reports.export.PDF': 'Eksportuoti PDF',
  'reports.export.XLS': 'Eksportuoti XLS',
  'reports.type': 'Pasirinkite..',
  'reports.type.warehouseProducts': 'Sandėlio žurnalai',
  'reports.type.clientProducts': 'Kliento žurnalai',
  'reports.type.excisableGoods': 'Akcizais apmokestinamų prekių',
  'reports.type.crm': 'CMR',
  'reports.type.crmRrme': 'Krovinio gabenimo važtaraštis',
  'reports.type.cmrReconciliationAct': 'CMR Suderinimo aktas',
  'reports.type.invoiceRegistrationLog': 'Važtaraščių registravimo žurnalas',
  'reports.type.receiptsReports': 'Gavimo ataskaitos',
  'reports.type.arrivalWagons': 'Atvykę vagonai',
  'reports.type.densityConversionLog': 'Tankio keitimo talpose žurnalas',
  'reports.filter.page': 'Lapo Nr.',
  'reports.filter.orderNo': 'Užsakymo numeris',
  'reports.filter.dateFrom': 'Data nuo',
  'reports.filter.dateTo': 'Data iki',
  'reports.filter.product': 'Produktas',
  'reports.filter.client': 'Klientas',
  'reports.filter.type': 'Tipas',
  'reports.filter.sender': 'Siuntėjas',
  'reports.filter.receiver': 'Gavėjas',
  'reports.filter.mainOrderNo': 'Bendras užsak. Nr.',
  'reports.filter.cmrNo': 'CMR numeris',
  'reports.filter.cmrRmeNo': 'Važtaraščio numeris',
  'reports.type.excisableGoods.reportTitle': 'Akcizais apmokestinamos prekės',
  'reports.type.excisableGoods.reportFullTitle':
    'AKCIZAIS APMOKESTINAMŲ PREKIŲ SANDĖLIO APSKAITOS ŽURNALAS',
  'reports.type.excisableGoods.rowNo': 'Eil. Nr.',
  'reports.type.excisableGoods.date': 'Data',
  'reports.type.excisableGoods.time': 'Laikas',
  'reports.type.excisableGoods.kpn': 'Prekės KPN kodas',
  'reports.type.excisableGoods.groupCode': 'Tarifinės grupės kodas',
  'reports.type.excisableGoods.title': 'Prekės pavadinimas',
  'reports.type.excisableGoods.uom': 'Prekės matav. vnt. (ltr)',
  'reports.type.excisableGoods.income': 'Pajamos',
  'reports.type.excisableGoods.operationCode': 'Operacijos kodas',
  'reports.type.excisableGoods.documentNo': 'Dokumento serija ir numeris',
  'reports.type.excisableGoods.qty': 'kiekis prie 15°C',
  'reports.type.excisableGoods.expenses': 'Išlaidos',
  'reports.type.excisableGoods.operationCode2': 'Operacijos kodas',
  'reports.type.excisableGoods.documentNo2': 'Dokumento serija ir numeris',
  'reports.type.excisableGoods.qty2': 'kiekis prie 15°C',
  'reports.type.excisableGoods.balanceAfter': 'Likutis Po',
  'reports.type.excisableGoods.leftQty': 'operacijos',
  'reports.type.excisableGoods.metersBeforeOper': 'Skaitikliai prieš oper.',
  'reports.type.excisableGoods.meters': 'skaitikliai po oper.',
  'reports.type.excisableGoods.responsiblePerson': 'Atsakingo asmens',
  'reports.type.excisableGoods.person': 'vardas, pavardė, parašas',
  'reports.type.excisableGoods.responsiblePersonSignature': 'Atsakingas asmuo',
  'reports.metersDataAfterOperations': 'SKAITIKLIŲ RODMENYS PO OPERACIJŲ',
  'reports.total': 'Suma',
  'reports.type.invoiceRegistrationLog.reportTitle':
    'Važtaraščių registravimo žurnalas',
  'reports.type.invoiceRegistrationLog.reportFullTitle':
    'VAŽTARAŠČIŲ REGISTRAVIMO ŽURNALAS',
  'reports.type.invoiceRegistrationLog.rowNo': 'Eil. Nr.',
  'reports.type.invoiceRegistrationLog.invoice': 'Važtaraščio',
  'reports.type.invoiceRegistrationLog.eventDateTime': 'Išrašymo data',
  'reports.type.invoiceRegistrationLog.orderNo': 'Numeris',
  'reports.type.invoiceRegistrationLog.companyInfo':
    'Gavėjo pavadinimas ir adresas',
  'reports.type.invoiceRegistrationLog.cargo': 'Siunčiamų krovinių',
  'reports.type.invoiceRegistrationLog.product': 'Pavadinimas',
  'reports.type.invoiceRegistrationLog.pvLtr': 'Kiekis fakt.',
  'reports.type.invoiceRegistrationLog.pvLtr15c': 'Kiekis +15C',
  'reports.type.invoiceRegistrationLog.pvKg': 'Kiekis kg.',
  'reports.type.invoiceRegistrationLog.reportGeneratedAt':
    'Ataskaita generuota',
  'reports.type.receiptsReports.reportTitle': 'Gavimo ataskaita',
  'reports.type.receiptsReports.reportFullTitle': 'GAVIMO ATASKAITA',
  'reports.type.receiptsReports.date': 'Data',
  'reports.type.receiptsReports.time': 'Laikas',
  'reports.type.receiptsReports.operationCode': 'Operacijos kodas',
  'reports.type.receiptsReports.fromPerson':
    'Asmens, iš kurio įsigyta / kuriam parduota',
  'reports.type.receiptsReports.title': 'pavadinimas (vardas, pavardė)',
  'reports.type.receiptsReports.identificationNo':
    'leidimo arba identifikacinis numeris (kodas)',
  'reports.type.receiptsReports.qty': 'Kiekis/masė',
  'reports.type.receiptsReports.qtyL': 'litrais esamos temperatūros',
  'reports.type.receiptsReports.qtyTemp': 'litrais + 15° C temperatūros',
  'reports.type.receiptsReports.qtyKg': 'kilogramais',
  'reports.type.receiptsReports.documentNo': 'Dokumento tipas, serija, numeris',
  'reports.type.receiptsReports.ownerTitle':
    'Produktų savininko pavadinimas ir kodas',
  'reports.type.conversionLog.reportTitle':
    'Tankio talpose pakeitimų registravimo žurnalas',
  'reports.type.conversionLog.reportFullTitle':
    'TANKIO TALPOSE PAKEITIMŲ REGISTRAVIMO ŽURNALAS',
  'reports.type.conversionLog.date': 'Data',
  'reports.type.conversionLog.capacity': 'Talpos Nr.',
  'reports.type.conversionLog.oldDencity': 'Senas tankis prie 15C',
  'reports.type.conversionLog.newDencity': 'Naujas tankis prie 15C',
  'reports.type.conversionLog.change': 'Pokytis',
  'reports.type.conversionLog.operator': 'Operatorius',
  'reports.type.arrivalWagons.reportTitle': 'Atvykę vagonai',
  'reports.type.arrivalWagons.reportFullTitle': 'ATVYKĘ VAGONAI',
  'reports.type.arrivalWagons.arrived': 'Atvyko',
  'reports.type.arrivalWagons.date': 'Data',
  'reports.type.arrivalWagons.seller': 'Pardavėjas',
  'reports.type.arrivalWagons.receiver': 'Gavėjas-(LG-sąskaita)',
  'reports.type.arrivalWagons.buyer': 'Pirkėjas',
  'reports.type.arrivalWagons.smgs': 'SMGS-Nr.',
  'reports.type.arrivalWagons.wagonNo': 'Vagono-Nr',
  'reports.type.arrivalWagons.document': 'Dokumento',
  'reports.type.arrivalWagons.documentDate': 'Data',
  'reports.type.arrivalWagons.documentNo': 'Nr.',
  'reports.type.arrivalWagons.qtyKg': 'Kiekis-KG',
  'reports.type.arrivalWagons.qtyL': 'Kiekis-LTR',
  'reports.type.arrivalWagons.earned': 'Pajamuota',
  'reports.type.arrivalWagons.postingKg': 'kg',
  'reports.type.arrivalWagons.receivedKg': 'kg',
  'reports.type.arrivalWagons.factReceived': 'Gauta faktas',
  'reports.type.products.reportTitle': 'Produktų ataskaita',
  'reports.type.products.reportFullTitle': 'PRODUKTŲ ATASKAITA',
  'reports.type.products.rowNo': 'Eil. Nr.',
  'reports.type.products.date': 'Data',
  'reports.type.products.time': 'Laikas',
  'reports.type.products.kpn': 'Prekės KPN kodas',
  'reports.type.products.groupCode': 'Tarifinės grupės kodas',
  'reports.type.products.title': 'Prekės pavadinimas',
  'reports.type.products.operationCode': 'Operacijos kodas',
  'reports.type.products.fromPerson':
    'Asmens, iš kurio įsigyta / kuriam parduota',
  'reports.type.products.toPerson': 'Asmens, kurio degalai priimti / išduoti',
  'reports.type.products.companyTitle': 'pavadinimas (vardas, pavardė)',
  'reports.type.products.companyIdentificationNo':
    'leidimo arba identifikacinis numeris (kodas)',
  'reports.type.products.qty': 'Kiekis/masė',
  'reports.type.products.qtyL': 'litrais esamos temperatūros',
  'reports.type.products.qtyTemp': 'litrais + 15° C temperatūros',
  'reports.type.products.qtyKg': 'kilogramais',
  'reports.type.products.documentNo': 'Dokumento tipas, serija, numeris',
  'reports.type.products.afterOperation': 'Likutis po operacijos',
  'reports.type.products.responsiblePerson': 'Atsakingo asmens',
  'reports.type.products.person': 'vardas, pavardė',
  'reports.chooseProduct': 'Produktas',
  'reports.dateFrom': 'Nuo',
  'reports.dateTo': 'Iki',
  'reports.noData': 'Nėra duomenų..',
  'analytics.title': 'Suvestinės',
  'analytics.material-traffic.title': 'Kuro judėjimas',
  'analytics.warehouse-traffic.title': 'Sandėlio judėjimas',
  'countersCorrections.title': 'Sulyginimai',
  'countersCorrection.title': 'Sulyginimas',
  'countersCorrection.edit_title': 'Sulyginimo redagavimas',
  'countersCorrection.create_title': 'Įvesti sulyginimą',
  'countersCorrection.delete_title': 'Sulyginimo šalinimas',
  'countersCorrection.created': 'Sulyginimas sukurtas',
  'countersCorrection.calculate': 'Apskaičiuoti',
  'countersCorrection.updated': 'Sulyginimas pakeistas',
  'countersCorrection.removed': 'Sulyginimas pašalintas',
  'countersCorrection.id': 'Nr.',
  'countersCorrection.eventDateTime': 'Data',
  'countersCorrection.eventDateTime.time': 'Laikas',
  'countersCorrection.weight': 'Kilogramai',
  'countersCorrection.volume': 'Litrai',
  'countersCorrection.volume15c': 'Litrai 15C',
  'countersCorrection.weightDiff': 'Kilogramai',
  'countersCorrection.volumeDiff': 'Litrai',
  'countersCorrection.volume15cDiff': 'Litrai 15C',
  'countersCorrection.confirmDelete': 'Ar tikrai norite pašalinti sulyginimą?',
  'internalOrders.title': 'Vidiniai užsakymai',
  'internalOrder.title': 'Vidinis užsakymas',
  'internalOrder.create_title': 'Įvesti vidinį užsakymą',
  'internalOrder.delete_title': 'Vidinio užsakymo šalinimas',
  'internalOrder.created': 'Vidinis užsakymas sukurtas',
  'internalOrder.updated': 'Vidinis užsakymas pakeistas',
  'internalOrder.removed': 'Vidinis užsakymas pašalintas',
  'internalOrder.filter': 'Ieškoti vidinio užsakymo...',
  'internalOrder.id': 'Nr.',
  'internalOrder.orderNo': 'eAD',
  'internalOrder.orderDateTime': 'Užsakymo data',
  'internalOrder.orderDateTime.time': 'Užsakymo laikas',
  'internalOrder.orderTypeId': 'Užsakymo tipas',
  'internalOrder.operationType': 'Tipas',
  'internalOrder.eventDateTime': 'Judėjimo data',
  'internalOrder.material': 'Produktas',
  'internalOrder.eventDateTime.time': 'Judėjimo laikas',
  'internalOrder.weight': 'Kilogramai',
  'internalOrder.volume': 'Litrai',
  'internalOrder.volume15c': 'Litrai 15C',
  'internalOrder.receiver': 'Gavėjas',
  'internalOrder.sender': 'Siuntėjas',
  'internalOrder.confirmDelete': 'Ar tikrai norite pašalinti vidinį užsakymą?',
  'internalOrder.order': 'Taisomas užsakymas',
  'internalOrder.errorEx': 'Grąžinamas užsakymas',
  'internalOrder.errorGr': 'Išvežimo užsakymas',
  'operationType.select': 'Užsakymo tipas',
  'unloadMeterData.fact': 'Faktas',
  'unloadMeterData.doc': 'Buhalterija',
  'unloadMeterData.diff': 'Skirtumas',
  'unloadMeterData.weight.short': 'kg',
  'unloadMeterData.volume.short': 'l',
  'unloadMeterData.volume15C.short': 'l',
  'unloadMeterData.density15C.short': 'kg/l',
  'weight.short': 'Kg',
  volume: 'Litrai',
  volume15C: 'Litrai15',
  'density15C.short': 'Kg/l',
  'railwayOrders.title': 'Palyginimai',
  'railwayOrders.tooltip': 'Gauto fakto sulyginimas su buhalterija',
  'railwayOrder.title': 'Palyginimas',
  'railwayOrder.title.create.panel': 'Pajamavimas',
  'railwayOrder.title.edit.panel': 'Pajamavimas',
  'railwayOrder.create_title': 'Įvesti pylimo užsakymą',
  'railwayOrder.delete_title': 'Pylimo užsakymo šalinimas',
  'railwayOrder.created': 'Pylimo užsakymas sukurtas',
  'railwayOrder.updated': 'Pylimo užsakymas pakeistas',
  'railwayOrder.removed': 'Pylimo užsakymas pašalintas',
  'railwayOrder.filter.eventDateTimeFrom': 'Data nuo',
  'railwayOrder.filter.eventDateTimeTo': 'Data iki',
  'railwayOrder.filter.material': 'Produktas',
  'railwayOrder.filter.eAd': 'eAD',
  'railwayOrder.filter.summary': 'Suminis',
  'railwayOrder.id': 'Nr.',
  'railwayOrder.eAd': 'eAD',
  'railwayOrder.eventDateTime': 'Atkrovimo data',
  'railwayOrder.eventDateTime.time': 'Atkrovimo laikas',
  'railwayOrder.weight': 'Kilogramai',
  'railwayOrder.volume': 'Litrai',
  'railwayOrder.volume15C': 'Litrai 15C',
  'railwayOrder.density15C': 'Tankis 15C',
  'railwayOrder.temperature': 'Temperatūra',
  'railwayOrder.receiver': 'GAVĖJAS',
  'railwayOrder.receiverName': 'Gavėjas',
  'railwayOrder.sender': 'SIUNTĖJAS',
  'railwayOrder.senderName': 'Siuntėjas',
  'railwayOrder.order': 'UŽSAKYMO INFORMACIJA',
  'railwayOrder.wagon': 'VAGONAI',
  'railwayOrder.summary': 'SKIRTUMAS',
  'railwayOrder.confirmDelete': 'Ar tikrai norite pašalinti pylimo užsakymą?',
  'railwayOrders.refresh': 'Atnaujinti pylimus',
  'railwayOrderDetail.tankerId': 'Vagono Nr.',
  'railwayOrderDetail.smgs': 'SMGS',
  'railwayOrderDetail.weight': 'Kilogramai',
  'railwayOrderDetail.volume': 'Litrai',
  'railwayOrderDetail.volume15C': 'Litrai 15C',
  'railwayOrderDetail.density15C': 'Tankis 15C',
  'railwayOrderDetail.remove': 'Pašalinti vagoną',
  'railwayOrderDetail.add': 'Pridėti vagoną',
  'button.save.tooltip': 'Saugoti',
  'button.cancel.tooltip': 'Atšaukti',
  'button.edit.tooltip': 'Redaguoti',
  'incomeOrders.title': 'Pajamavimas',
  'incomeOrders.filter.ead': 'eAD numeris...',
  'incomeOrder.eAD': 'eAD',
  'incomeOrder.eventDateTime': 'Data',
  'incomeOrder.sender': 'Siuntėjas',
  'incomeOrder.confirmDelete': 'Ar tikrai norite pašalinti pajamavimą?',
  'incomeOrders.create.trailerUnloadOrder.title': 'Pajamuoti iš mašinos',
  'incomeOrders.create.railwayOrder.title': 'Pajamuoti iš vagonų',
  'incomeOrders.trailerUnloadOrder.removed': 'Pajamavimas pašalintas',
  'incomeOrders.railwayOrder.removed': 'Pajamavimas pašalintas',
  'trailerUnloadOrder.title': 'Pajamavimas',
  'trailerUnloadOrder.delete_title': 'Pajamavimo šalinimas',
  'trailerUnloadOrder.created': 'Pajamavimas sukurtas',
  'trailerUnloadOrder.updated': 'Pajamavimas pakeistas',
  'trailerUnloadOrder.removed': 'Pajamavimas pašalintas',
  'trailerUnloadOrder.id': 'Nr.',
  'trailerUnloadOrder.eAD': 'eAD',
  'trailerUnloadOrder.cmr': 'CMR',
  'trailerUnloadOrder.eventDateTime': 'Data',
  'trailerUnloadOrder.eventDateTime.time': 'Laikas',
  'trailerUnloadOrder.weight': 'Kilogramai',
  'trailerUnloadOrder.volume': 'Litrai',
  'trailerUnloadOrder.volume15c': 'Litrai 15C',
  'trailerUnloadOrder.density15C': 'Tankis 15C',
  'trailerUnloadOrder.temperature': 'Temperatūra',
  'trailerUnloadOrder.receiver': 'Gavėjas',
  'trailerUnloadOrder.sender': 'Siuntėjas',
  'trailerUnloadOrder.vehicle': 'Mašina',
  'trailerUnloadOrder.trailer': 'Priekaba',

  'tableReport.filter.object': 'Objektas',
  'tableReport.filter.report': 'Ataskaita',
  'tableReport.filter.dateFrom': 'Data nuo',
  'tableReport.filter.dateTo': 'Data iki',
  'tableReport.filter.timeSpan': 'Tikslumas',
  'tableReport.object': 'Objektas',
  'tableReport.equipment': 'Įrenginys',
  'tableReport.parameter': 'Parametras',
  'tableReport.date.unit': 'Data / Matavimo vienetas',
  'tableReport.aggregationType': 'Agregavimo tipas',

  'timeSpan.select': 'Tikslumas',
  'time.span.pretimespan': 'Prieš ',
  'time.span.MINUTE': 'Minutė',
  'time.span.minutes': 'min.',
  'time.span.HOUR': 'Valanda',
  'time.span.hours': 'val.',
  'time.span.DAY': 'Para',
  'time.span.days': 'd.',
  'timeInterval.select': 'Stebimas laikotarpis',
  'time.interval.THIS_MONTH': 'Einamas mėnuo',
  'time.interval.LAST_MONTH': 'Praėjęs mėnuo',
  'time.interval.LAST_WEEK': 'Praėjusi savaitė',
  'time.interval.SELECTED_DATES': 'Laikotarpis',
  'time.interval.THIS_DAY': 'Einamoji diena',
  'time.interval.LAST_DAY': 'Praėjusi diena',
  'time.interval.SELECTED_DAY': 'Pasirinkti kitą dieną',
  'time.interval.DAY': 'Diena',
  'time.interval.WEEK': 'Savaitė',
  'time.interval.YEAR': 'Einamieji metai',
  'time.interval.ALL_RECORDS': 'Visi įrašai',
  'time.period.select': 'Stebimas laikotarpis',
  'time.tooFar.1h': 'Galima įvesti tik viena valanda vėlesnį laiką',

  'objectReport.select': 'Ataskaita',
  'displayType.select': 'Atvaizdavimo būdas',

  // FACTORY
  'factory.events': 'Parametrai',

  // DANPOWER
  'danpower.events': 'Parametrai',
  'danpower.events.title': 'Parametrai',
  'danpower.event.site': 'Vieta',
  'danpower.event.object': 'Įrenginys',
  'danpower.event.eventDateTime': 'Laikas',
  'danpower.events.filter.site': 'Vieta',
  'danpower.events.filter.object': 'Įrenginys',
  'danpower.events.filter.parameter': 'Parametras',
  'danpower.events.filter.search': 'Ieškoti',

  'schemas.title': 'Schemos',
  'schemas.inidcator.status.neutral': 'Neutralus',
  'schemas.inidcator.status.danger': 'Pavojus',
  'schema.modify.title': 'Redagavimas',
  'schema.create.title': 'Schemos kūrimas',
  'schema.name': 'Pavadinimas',
  'schema.image': 'Schemos paveikslėlis',
  'schema.indicators.select': 'Parametro parinkimas',
  'schema.object': 'Objektas',
  'schema.indicator.search': 'Parametras',
  'schema.indicator.add': 'Pridėti',
  'schema.added.indicators': 'Schema',
  'schema.indicators.validation.error': 'Neparinktas nė vienas parametras',
  'schema.created': 'Schema sukurta',
  'schema.updated': 'Schema atnaujinta',
  'schema.removed': 'Schema pašalinta',
  'schema.edit': 'Redaguoti',
  'schema.delete': 'Pašalinti',
  'schema.create': 'Sukurti schemą',
  'schema.upsert.error': 'Schemos nepavyko išsaugoti',
  'schema.remove.confirm': 'Ar tikrai norite pašalinti schemą?',
  'schema.remove.error':
    'Schemos negalima pašalinti, nes ji turi sąryšių (pvz. Rodikliai).',
  'schema.indicator.popover.minLimit': 'Min.: {minLimit}{abbreviation}',
  'schema.indicator.popover.maxLimit': 'Maks.: {maxLimit}{abbreviation}',

  'dropzone.add.file.here':
    'Nutempkite failą čia arba paspauskite, kad pasirinktumėte iš sąrašo',

  'warehouses.title': 'Sandėliai',
  'warehouse.code': 'Kodas',
  'warehouse.create.title': 'Sandėlio kūrimas',
  'warehouse.modify.title': 'Sandėlio redagavimas',
  'warehouse.name': 'Pavadinimas',
  'warehouse.object': 'Objektas',
  'warehouse.title': 'Sandėliai',
  'warehouse.create.tooltip': 'Kurti sandėlį',
  'warehouse.updated': 'Sandėlys atnaujintas',
  'warehouse.created': 'Sandėlys sukurtas',
  'warehouse.removed': 'Sandėlys pašalintas',
  'warehouse.delete.confirm': 'Ar tikrai norite pašalinti sandėlį?',
  'warehouse.upsert.error': 'Sandėlio nepavyko išsaugoti',

  'warehouseGoods.title': 'Sandėlio detalės',
  'warehouseGood.create.title': 'Sandėlio detalės kūrimas',
  'warehouseGood.modify.title': 'Sandėlio detalės redagavimas',
  'warehouseGood.name': 'Pavadinimas',
  'warehouseGood.code': 'Kodas',
  'warehouseGood.price': 'Vieneto kaina',
  'warehouseGood.budgetCode': 'Biudžeto kodas',
  'warehouseGood.document': 'Pirkimo dokumentas',
  'warehouseGood.title': 'Sandėlio detalė',
  'warehouseGood.unit': 'Mat. vnt.',
  'warehouseGood.initialAmount': 'Pradinis kiekis',
  'warehouseGood.create.tooltip': 'Kurti sandėlio detalę',
  'warehouseGood.updated': 'Sandėlio detalė atnaujinta',
  'warehouseGood.created': 'Sandėlio detalė sukurta',
  'warehouseGood.removed': 'Sandėlio detalė pašalinta',
  'warehouseGood.upsert.error': 'Sandėlio detalės nepavyko išsaugoti',
  'warehouseGood.remove.error':
    'Sandėlio detalės nebegalima pašalinti nes jis turi sąryšių',
  'warehouseGood.delete.confirm': 'Ar tikrai norite pašalinti sandėlo detalę?',

  'warehouseGoods.filter.name': 'Pavadinimas',
  'warehouseGoods.filter.code': 'Kodas',
  'warehouseGoods.filter.balanceStatus': 'Būsena sandėlyje',
  'warehouseGood.balanceStatus.all': 'Visi',
  'warehouseGood.balanceStatus.full': 'Pilnas kiekis',
  'warehouseGood.balanceStatus.empty': 'Išnaudotas kiekis',
  'warehouseGood.balanceStatus.missing': 'Trūkstamas kiekis',
  'warehouseGood.export.includeZeroStartingAmount': 'Įtraukti su nuliniais pradiniais likučiais',

  'warehouseGoodAction.amount.overBalance': 'Nepakanka likučio',
  'warehouseGoodAction.upsert.error': 'Likučio nepavyko išsaugoti',
  'warehouseGoodsItem.code': 'Kodas: {code}',
  'warehouseGoodsItem.oldCode': 'Senas kodas: {code}',
  'warehouseGoodsItem.initialAmount': 'Kiekis: {initialAmount} {unit}',
  'warehouseGoodsItem.balance': 'Likutis: {balance} {unit}',
  'warehouseGoodReplenish.initialAmount': 'Papildyti',
  'warehouseGoodReplenish.date': 'Data',
  'not.found.page.header': 'Turinys neegzistuoja',
  'not.found.page.message':
    'Atsiprašome, turinys neegzistuoja arba neturite prieigos teisių.',
  'not.found.page.go.back': 'Grįžti',

  'fixedAsset.title': 'Ilgalaikio turto objektas',
  'fixedAsset.code': 'R kodas',

  'repairs.title': 'Remontai',
  'yearly.repairs.title': 'Metiniai Remontai',
  'repair.code': 'Kodas',
  'repair.create.title': 'Remonto kūrimas',
  'repair.modify.title': 'Remonto redagavimas',
  'repair.name': 'Pavadinimas',
  'repair.object': 'Objektas',
  'repair.title': 'Remontai',
  'repair.create.tooltip': 'Kurti remontą',
  'repair.updated': 'Remontas atnaujintas',
  'repair.created': 'Remontas sukurtas',
  'repair.removed': 'Remontas pašalintas',
  'repair.delete.confirm': 'Ar tikrai norite pašalinti remontą?',
  'repair.upsert.error': 'Remonto nepavyko išsaugoti',
  'repair.plannedDateOfWork.time': 'Laikas',
  'repair.plannedDateOfWork.date': 'Data',

  'repair.group': 'Įrenginių grupė',
  'repair.equipment': 'Įrenginys',
  'repair.description': 'Aprašymas',
  'repair.plannedDate': 'Darbo planuojama data',
  'repair.finishedDate': 'Darbo baigimo data',
  'repair.doneDate': 'Darbo atlikimo data',
  'repair.worker': 'Atliekama darbuotojų',
  'repair.workPrice': 'Darbas, €',
  'repair.materialPrice': 'Medžiagos, €',
  'repair.totalCost': 'Suma, €',
  'repair.offer': 'Sprendimas pirkti',

  "repair.import.error.missingFields": "Eilutė {row}: Trūksta reikiamų laukų.",
  "repair.import.error.unknownArea": "Eilutė {row}: Nežinoma įrenginių grupė {areaName}.",
  "repair.import.error.unknownEquipment": "Eilutė {row}: Nežinomas įrenginys {equipmentName} arba jis nepriklauso šiam žurnalui.",
  "repair.import.error.equipmentAreaMismatch": "Eilutė {row}: Įrenginys {equipmentName} nepriklauso įrenginių grupei {areaName}.",
  "repair.import.error.equipmentJournalMismatch": "Eilutė {row}: Įrenginys {equipmentName} nepriklauso tam pačiam objektui kaip žurnalas.",
  "repair.import.error.invalidDateFormat": "Eilutė {row}: Neteisingas datos formatas {dateValue}.",
  "repair.import.error.invalidDate": "Eilutė {row}: Neteisinga data {dateValue}.",
  "repair.import.error.failedToCreateIssue": "Eilutė {row}: Nepavyko sukurti įrašo. Klaida: {error}",
  "repair.import.error.failedToImport": "Nepavyko importuoti įrašų. Klaida: {error}",
  "repair.import.error.journal.notFound": "Žurnalas nerastas",
  "repair.import.success.message": "Sėkmingai importuota {count} įrašų.",

  "repair.export.warning.selectYear": "Pasirinkite metus prieš eksportuodami",

  "annualRepair.removed": "Metinis remontas pašalintas",
  "select.year": "Pasirinkite metus",
  "Year": "Metai",
  "export.success": "Eksportas sėkmingas",

  'repairObjects.values.saved': 'Reikšmės išsaugotos',
  'repairObjects.unplannedExpense': 'Neplaninės Sąnaudos',
  'repairObjects.unplannedCost': 'Nenumatyti darbai',
  'repairObjects.plannedRepairsSum': 'Planiniai remontai',
  'repairObjects.unplannedExpenseTotal': 'Neplaninių sąnaudų suma',
  'repairObjects.unplannedCostTotal': 'Nenumatytų darbų suma',
  'repairObjects.plannedRepairsSumTotal': 'Planinių remontų suma',
  'repairObjects.grandTotal': 'Bendra suma',
  'common.save': 'Išsaugoti',
  'common.actions': 'Veiksmai',
  'year': 'Metai',
  
  'yes': 'Taip',
  'no': 'Ne',

  '[object Object]': "Objektas",
  
  'dashboard.title': 'Rodikliai',
  'gadget.create.tooltip': 'Pridėti rodiklį',
  'gadget.form.type': 'Pasirinkite tipą',
  'gadget.form.type.chart': 'Realaus Laiko Grafikas',
  'gadget.form.type.table': 'Lentelė',
  'gadget.form.type.schema': 'Schema',
  'gadget.form.type.graph': 'Grafikas',
  'gadget.form.type.status': 'Status',
  'gadget.form.item': 'Pasirinkite objektą',
  'gadget.form.parameters': 'Pasirinkite parametrus',
  'gadget.form.name': 'Pavadinimas',
  'gadget.delete.confirm': 'Ar tikrai norite pašalinti rodiklį?',
  'gadget.updated': 'Rodiklis atnaujintas',
  'gadget.created': 'Rodiklis sukurtas',
  'gadget.removed': 'Rodiklis pašalintas',
  'gadget.notify': 'Siųsti el. laišku',
  'gadget.notifyPeriod': 'Kartojimo periodas',
  'gadget.notifyPeriod.MONTH': 'Kartoti kas mėnesį',
  'gadget.notifyPeriod.WEEK': 'Kartoti kas savaitę',
  'gadget.notifyPeriod.DAY': 'Kartoti kas dieną',
  'gadget.notifyDelay': 'Siuntimo diena',
  'gadget.notifyTime': 'Siuntimo laikas',
  'gadget.dateFrom': 'Data nuo',
  'gadget.dateTo': 'Data iki',
  'gadget.day': 'Diena',
  'gadget.upsert.error': 'Rodiklio nepavyko išsaugoti',

  'chart.modify.title': 'Grafiko redagavimas',
  'chart.create.title': 'Grafiko kūrimas',
  'chart.name': 'Grafiko pavadinimas',
  'chart.object': 'Objektas',
  'chart.indicators.select': 'Parametrų pasirinkimas',
  'chart.indicator.add': 'Pridėti',
  'chart.added.indicators': 'Pridėti parametrai',
  'chart.indicator.search': 'Pasirinkti parametrą...',
  'chart.created': 'Grafikas sukurta',
  'chart.updated': 'Grafikas atnaujintas',
  'chart.create.tooltip': 'Kurti grafiką',
  'chart.modify': 'Redaguoti',
  'chart.remove': 'Pašalinti',
  'chart.remove.confirm': 'Ar tikrai norite pašalinti grafiką?',
  'chart.removed': 'Grafikas sėkmingai pašalinta',
  'chart.indicators.validation.error': 'Nepridėtas nė vienas parametras',
  'chart.upsert.error': 'Grafiko nepavyko išsaugoti',

  'materialType.PURE': 'Grynas produktas',
  'materialType.MIXED': 'Maišytas produktas',
  'materialType.ADT-PIGM': 'Priedas',

  'status.object': 'OBJEKTAS',
  'status.production': 'GAMYBA',
  'status.prices': 'KAINA',
  'status.income': 'PAJAMOS',
  'status.averageCapacity': 'VIDUTINIS PAJĖGUMAS',
  'status.downtime': 'PRASTOVA, H',
  'status.downtime.OPEN': 'Veikia',
  'status.downtime.PARTLY': 'Stabdoma',
  'status.downtime.CLOSED': 'Neveikia',
  'status.status': 'STATUSAS',
  'status.electricity': 'Elektra',
  'status.heat': 'Šiluma',
  'status.total': 'Viso',

  'journal.export.excel': 'Excel',
  'journal.export.excel.error': 'Nepavyko suformuoti excel',
  'notifications.title': 'Pranešimai',
  'notifications.none.found': 'Šiuo metų naujų pranešimų neturite',
  'user.accessPricing': 'Prieiga prie kainų',
  'user.manageEvents': 'Įvykių valdymas',
  'user.manageWarehouses': 'Sandėlių valdymas',
  'user.manageRepairs': 'Remontų valdymas',
  'user.manageRepairBudget': 'Remontų biudžeto valdymas',
  'user.issueTaskExecutor': 'Vykdytojas',
  "user.canApproveRecommendations": "Rekomendacijų tvirtinimas",
  prices: 'Kainos',
  'prices.title': 'Kainos',
  'prices.ELECTRICITY': 'Elektra',
  'prices.HEAT': 'Šiluma',
  object: 'Objektas',
  indicator: 'Parametras',
  'indicatorPrice.removed': 'Kaina pašalinta',
  'price.objectFilter': 'Objektas',
  'price.nameFilter': 'Parametras',
  'price.create.title': 'Parametro kainos',
  'price.modify.title': 'Parametro kainos',
  'indicatorPrice.type': 'Tipas',
  'indicatorPrice.newPrice': 'Nauja Kaina',
  'indicatorPrice.date': 'Data',
  'indicatorPrice.hour': 'Valanda',
  'indicatorPrice.price': 'Kaina',
  'indicatorPrice.prices': 'Galiojančios kainos',
  'indicatorPrice.add': 'Pridėti',
  'indicatorPrice.indicator.unique': 'Šis parametras jau turi kainą',
  'indicatorPrice.uniqueDate': 'Šiam laikui kaina jau yra priskirta',
  'indicatorPrice.created': 'Kaina sukurta',
  'indicatorPrice.updated': 'Kaina atnaujinta',
  'indicatorPrice.delete.confirm': 'Ar tikrai norite pašalinti kainą',
  'indicatorPrice.title': 'Pavadinimas',
  'graph.type.STANDART': 'Laikotarpis',
  'graph.type.REAL_TIME': 'Realaus laiko',
  'graph.type.select': 'Grafiko tipas',
  'indicator.filter.name': 'Pavadinimas',
  'indicator.filter.code': 'Kodas',
  'export.tooltip': 'Eksportuoti',
  'export.previous': 'Paskutinis exportas',
  'export.noPreviousExportFound': 'Nerasta jokių exportų',
  dateFrom: 'Data nuo',
  dateTo: 'Data iki',
  'export.warehouseGood.nr': 'Eil. Nr.',
  'export.warehouseGood.code': 'Kodas',
  'export.warehouseGood.budgetCode': 'Biudžeto kodas',
  'export.warehouseGood.name': 'Pavadinimas',
  'export.warehouseGood.document': 'Pirkimo Dokumentas',
  'export.warehouseGood.firstCreated': 'Atsargos pridėjimo data',
  'export.warehouseGood.start': 'Pradiniai duomenys',
  'export.warehouseGood.used': 'Sunaudota',
  'export.warehouseGood.leftOver': 'Likutis',
  'export.warehouseGood.amount': 'Kiekis',
  'export.warehouseGood.unit': 'Mat vnt',
  'export.warehouseGood.price': 'Kaina',
  'export.warehouseGood.sum': 'Suma',
  'export.warehouseGood.all': 'Iš viso:',

  'import.tooltip': 'Importuoti',
  

  'support.page.menu': 'Susisiekite',
  'support.page.header': 'Susisiekite',
  'support.page.message':
    'Klausimų ir pastebėjimų laukiame ' +
    '<a href="mailto:support@axs.eu">support@axs.eu</a> .',
  'import.prices': 'Kainų Importavimas',
  'import.prices.successfull': 'Kainų importavimas buvo sėkmingas',
  'import.format.wrong': 'Neteisingas failo formatas',

  addons: 'Moduliai',

  adminAddon: 'Administravimo modulis',
  'adminAddon.description': 'Prieigos teisių administravimas',
  objectInfoAddon: 'ObjectInfo modulis',
  'objectInfoAddon.description': 'Objekto informacija',
  analyticsAddon: 'Analitikos addon',
  'analyticsAddon.title': 'Analitika',
  'analyticsAddon.filter': 'Filtruoti elementus',
  'analyticsAddon.permissions': 'Nustatyti prieigas',
  'analyticsAddon.description': 'Analitikos addon modulis',
  'analyticsAddon.new': 'Naujas elementas',
  'analyticsAddon.edit': 'Redaguoti elementą',
  'analyticsAddon.delete': 'Ar tikrai norite ištrinti šį modulį?',
  'analyticsAddon.form.name': 'Pavadinimas',
  'analyticsAddon.form.description': 'Aprašymas',
  'analyticsAddon.form.datalakeid': 'Data Lake ID',
  'analyticsAddon.form.created': 'Analitika buvo sekmingai sukurta',
  'analyticsAddon.form.updated': 'Analitika buvo sekmingai atnaujinta',
  'analyticsAddon.form.deleted': 'Analitika buvo sekmingai pašalintas',
  lithoil: 'Lithoil modulis',
  'lithoil.description': 'Dujų ir dyzelio terminalai',
  flexiCore: 'FlexiCore modulis',
  'flexiCore.description': 'Pagrindinis sistemos modulis',
  shifts: 'Pamainų addon',
  'shifts.description': 'Pamainų addon modulis',
  'adminAddon.manageUsers.title': 'Naudotojų valdymas',
  'adminAddon.managePermissions': 'Nustatyti prieigas',
  'adminAddon.managePermissions.title': 'Teisių valdymas',
  'adminAddon.managePermissions.added': 'Teisė suteikta',
  'adminAddon.managePermissions.removed': 'Teisė atšaukta',
  'adminAddon.search': 'Ieškoti priedo arba naudotojo...',
  'adminAddon.searchClient': 'Ieškoti kliento...',
  'adminAddon.searchAddon': 'Ieškoti priedo...',
  'adminAddon.header': 'Flexi moduliai',
  'adminAddon.subheader':
    'Moduliai tai yra „Flexi“ produkto papildiniai, kurie klientų naudotojams prideda naujų funkcijų ar galimybių.',
  refresh: 'Atnaujinti',
  'lack.of.privileges': 'Nepakankamos prieigos teisės',
  'adminAddon.enableAll': 'Įjungti visiems',
  'adminAddon.disableAll': 'Įšjungti visiems',
  'adminAddon.searchUser': 'Ieškoti naudotojo...',
  'no.privileges':
    'Jūs neturite teisės atidaryti turinio. Susisiekite su savo sistemos administratoriumi.',
  selected: 'Pasirinktas',

  flexiBi: 'Flexi BI modulis',
  'flexiBi.description': 'Grafikų stebėsenos modulis',
  'flexiBi.administration.title': 'Administravimas',
  'flexiBi.users.title': 'Naudotojai',
  'flexiBi.clients.title': 'Klientai',

  'subclients.error': 'Konfigūracijos klaida [subclients.error]. Kreipkitės į sitemos administratorius.',

  server: 'serveris',
  'server.error': 'įvyko nenumatyta serverio klaida, prašome pabandyti vėliau',
  emailSent: 'Jeigu sistemoje registruotas pateiktas el. pašto adresas - laiškas su slaptažodžio atnaujinimo instrukcija išsiūstas',

  'purchaseDecision.title': 'Sprendimas pirkti',
  'purchaseDecision.download': 'Parsisiųsti sprendimo pirkti aktą',
  'purchaseDecision.recomendationSaved': 'Rekomendacija pateikta',
  'purchaseDecision.failedToSave': 'Nepavyko pateikti rekomendacijos',
  'purchaseDecision.cancelRecommendation': 'Atšaukti rekomendaciją',
  'purchaseDecision.canceled': 'Rekomendacija atšaukta',
  'purchaseDecision.failedToCancel': 'Nepavyko atšaukti rekomendacijos',
  'offers': 'Pasiūlymai',
  'offer.no': 'Nr.',
  'offer.company': 'Pasiūlymo bendrovė',
  'offer.service': 'Produktas/paslauga',
  'offer.price': 'Pilna kaina €',
  'offer.notes': 'Sprendimo kriterijai',
  'offer.add': 'Pridėti pasiūlymą',
  'offer.remove': 'Pašalinti pasiūlymą',
  'purchaseOffer.removed': "Pasiūlymas ištrintas",
  'offer.recommendation': 'Rekomendacija',
  'offer.percentage': 'Procentai %',
  'offer.confirmedBudget': 'Patvirtintas biudžetas',
  'offer.budgetPrice': 'Biudžeto eilutė',
  'purchaseOffers.updated': 'Sprendimai pirkti atnaujinti',
  'pruchaseDecision.confirmation': 'Patvirtinimas',
  'pruchaseDecision.approversSelect': 'Tvirtintojų priskyrimas',
  'pruchaseDecision.addApprover': 'Pridėti tvirtintoją',
  'approval.approved': 'Patvirtinta',
  'approval.notApproved': 'Nepatvirtinta',
  'approval.status': 'Statusas',
  'approval.approver': 'Tvirtintojas',
  'approval.confirmation': 'Tvirtinimas',
  'approval.confirmed': 'Patvirtinta',
  'approval.failedToConfirm': 'Patvirtinti nepavyko',

  'numberMustBeMoreThanZero': "Skaičius turi būti daugiau negu 0",

  'privacyPolicy.title': 'Flexi privatumo politika',
  'privacyPolicy.page.title': 'Privatumo politika',
  'privacyPolicy.openPdf': 'Atidaryti PDF',
  'privacyPolicy.pdfNotSupported': 'Naršyklė negali parodyti PDF failo.',
};
